/* eslint-disable no-autofix/snakecasejs/snakecasejs, one-var-declaration-per-line, one-var  */
// Imports
import * as modules from './partials/modules';
import FF_Module from './modules/FF_Module';
import { ff_merge_objects } from './utils/objects';
import { ff_load_file } from './utils/files';
import { ff_ajax } from './utils/ajax';

// Variables globales
window.ff_scroll = null;
window.ff_animations = new modules.FF_Animations();
window.ff_device_data = null;
window.ff_grid = null;
window.FF_Module = FF_Module;
window.__ = wp.i18n.__; // eslint-disable-line no-underscore-dangle
window._x = wp.i18n._x; // eslint-disable-line no-underscore-dangle
window._n = wp.i18n._n; // eslint-disable-line no-underscore-dangle
window._nx = wp.i18n._nx; // eslint-disable-line no-underscore-dangle
window.rem = 18;
window.vh = window.innerHeight;
window.vw = window.innerWidth;
window.limit_animations = false;
window.media_queries = {
  large_desktop_only      : '(min-width: 2100px)',
  desktop_only            : '(min-width: 1200px)',
  tablet_and_down         : '(max-width: 1199px)',
  tablet_only             : '(max-width: 1199px) and (min-width: 750px)',
  landscape_tablet_only   : '(max-width: 1199px) and (min-width: 750px) and (orientation: landscape)',
  portrait_tablet_and_down: '(max-width: 1199px) and (orientation: portrait), screen and (max-width: 749px)',
  portrait_tablet_only    : '(max-width: 1199px) and (orientation: portrait) and (min-width: 750px)',
  laptop_and_down         : '(max-width: 1024px)',
  small_tablet_and_down   : '(max-width: 849px)',
  phone_only              : '(max-width: 749px)',
  landscape_phone_only    : '(min-width: 500px) and (max-width: 749px) and (orientation: landscape)'
};

// Variables dans la portée du fichier
let ff_last_scroll_pos = 0;
let current_page_initial_html = '';
let ff_sliders = [];
let ff_gliders = [];
let google_maps = [];
let plyr_players = [];
let page_has_loaded = false;
let screen_menu;
let cart_notification_timeout = null;

/* eslint-enable no-autofix/snakecasejs/snakecasejs, one-var-declaration-per-line, one-var  */

// ================================================================================================================
// Charge les traductions de chaînes pour le fichier
// ================================================================================================================
const i18n_data_promise = ff_load_i18n_data();

/***
 *    ##        #######     ###    ########
 *    ##       ##     ##   ## ##   ##     ##
 *    ##       ##     ##  ##   ##  ##     ##
 *    ##       ##     ## ##     ## ##     ##
 *    ##       ##     ## ######### ##     ##
 *    ##       ##     ## ##     ## ##     ##
 *    ########  #######  ##     ## ########
 */
const page_load_promise = new Promise((resolve) => {
  $(window).on('load', () => {
    ff_update_proportional_rem();
    $('html').addClass('page-loaded');
    page_has_loaded = true;
    resolve();
  });
});

// Lors du "unloading" de la page, on fait une petite animation de transition
$(window).on('beforeunload', () => {
  $('html').addClass('barba-transitioning');
  gsap.to('main, .header, .footer', { opacity: 0, duration: 0.45, ease: CustomEase.create('custom', 'M0,0,C0.7,0,0.6,0.814,1,1') });
});
$(window).on('unload', () => { // Failsafe au cas où le "unload" soit annulé
  setTimeout(() => {
    $('html').addClass('barba-transitioning');
    gsap.set('main, .header, .footer', { opacity: 1 });
  });
});


/***
*    ########   #######   ######     ########  ########    ###    ########  ##    ##
*    ##     ## ##     ## ##    ##    ##     ## ##         ## ##   ##     ##  ##  ##
*    ##     ## ##     ## ##          ##     ## ##        ##   ##  ##     ##   ####
*    ##     ## ##     ## ##          ########  ######   ##     ## ##     ##    ##
*    ##     ## ##     ## ##          ##   ##   ##       ######### ##     ##    ##
*    ##     ## ##     ## ##    ##    ##    ##  ##       ##     ## ##     ##    ##
*    ########   #######   ######     ##     ## ######## ##     ## ########     ##
*/
$(async () => { // *Méthode recommandée de jQuery pour le "doc ready" (Équivalent à $(document).ready())

  await i18n_data_promise; // On attend que les traductions de chaînes soient complètement chargées avant de continuer
  console.log(__('%cCréé avec ❤️ + ☕️ + 🍺 par fatfish - créations web.', 'fatfish'), 'padding: 0.2em 0.6em; color: #fff; font-size: 0.75rem; background-color: #B2272B; border-radius: 0.4em;');

  // ================================================================================================================
  // Intialisation des modules
  // ================================================================================================================
  FF_Module.init(modules);

  // ================================================================================================================
  // Détection des informations d'appareils et de navigateur
  // ================================================================================================================
  ff_device_data = new modules.FF_Device_Data();

  // ================================================================================================================
  // Gestion du 'limit_animations'
  // ================================================================================================================
  const formatted_version = operating_system_version.split('.', 2).join('.');
  limit_animations = [
    operating_system == 'Android' && formatted_version < 10, // Android < 10
    operating_system == 'Mac OS' && formatted_version < 10, // Mac OS < 10
    operating_system == 'iOS' && formatted_version < 14, // iOS < 14
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ].some(Boolean);
  if (limit_animations) {
    $('html').addClass('has-limited-animations');
  }

  // ================================================================================================================
  // Lorsque la page est redimensionnée
  // ================================================================================================================
  ff_update_display_vars();
  ff_update_proportional_rem();

  let old_vw = window.innerWidth;
  $(window).on('resize', () => {
    ff_update_display_vars();
    ff_update_proportional_rem();
    if (vw != old_vw) {
      ff_fix_vh();
      old_vw = vw;
    }
  });

  $(window).on('orientationchange', () => {
    ff_update_display_vars();
    ff_update_proportional_rem();
    ff_fix_vh();
    old_vw = vw;
  });

  // ================================================================================================================
  // Configuration par défaut GSAP
  // ================================================================================================================
  gsap.registerPlugin(CustomEase, SplitText); // eslint-disable-line no-autofix/snakecasejs/snakecasejs
  gsap.config({
    nullTargetWarn: false
  });

  // Eases
  CustomEase.create('custom.inOutSlowOut', 'M0,0,C0.084,0,0.148,0.056,0.196,0.134,0.259,0.237,0.3,0.36,0.362,0.5,0.412,0.613,0.47,0.736,0.582,0.848,0.7,0.966,0.778,1,1,1');
  CustomEase.create('custom.slowMo', 'M0,0 C0,0 0.03,0.093 0.115,0.2 0.225,0.34 0.382,0.415 0.5,0.5 0.92,0.802 0.968,0.951 1,1 ');

  // ================================================================================================================
  // Init FFScroll
  // ================================================================================================================
  ff_scroll = new FFScroll({ duration: 1.5, wheelMultiplier: 1.1 });
  ff_scroll.lock_scroll();
  ff_setup_gsap_scroll_trigger();

  // ================================================================================================================
  // FF Grid
  // ================================================================================================================
  ff_grid = new modules.FF_Grid();

  // ================================================================================================================
  // Instanciation de l'écran de menu
  // ================================================================================================================
  screen_menu = new modules.FF_Screen_Menu();

  // ================================================================================================================
  // Initialisation de Barba
  // ================================================================================================================
  ff_init_barba_routing();

  // ================================================================================================================
  // Initialisation des outils de référencement pour notre REM proportionnel
  // ================================================================================================================
  ff_init_responsive_rem_tool();

  // ================================================================================================================
  // Gestion des classes de direction de scroll
  // ================================================================================================================
  ff_scroll.add_scroll_listener($.throttle(() => {
    $('html')[ff_scroll.get_scroll_top() > 5 ? 'addClass' : 'removeClass']('scrolled');
    $('html')[ff_scroll.lenis.direction == 1 ? 'addClass' : 'removeClass']('scrolling-down');
    $('html')[ff_scroll.lenis.direction == -1 ? 'addClass' : 'removeClass']('scrolling-up');
  }), 200);

  // ================================================================================================================
  // Ajout des écouteurs au clic des boutons d'ajout au panier
  // ================================================================================================================
  $('body').on('click', '.add-to-cart-button', (e) => {
    const button = e.currentTarget;
    const product_id = parseInt($(button).attr('data-product-id'));
    const product_variation_id = parseInt($(button).attr('data-product-variation-id'));
    if (product_id && product_variation_id) {
      ff_add_to_cart(product_id, product_variation_id, button);
    }
  });

  // ================================================================================================================
  // Lors de la mise à jour du HTML par WooCommerce on transforme les champs de quantité et on met à jour la barre de scroll de FFScroll
  // ================================================================================================================
  $(document.body).on('updated_wc_div', () => {
    ff_transform_quantity_inputs();
    if (ff_scroll.scrollbar) {
      ff_scroll.scrollbar.refresh();
    }
  });

  // ================================================================================================================
  // Lors de la mise à jour du "checkout" (Page paiement), on réinitialise les CTAs qui le requiert
  // ================================================================================================================
  $(document.body).on('updated_checkout', () => {
    $('.cta:not(.cta--instanciated)').each((i, cta_element) => {
      modules.FF_CTA.create(cta_element);
    });
  });

  // ================================================================================================================
  // Lors de la mise à jour du total du panier, on calcule la quantité d'items de celui-ci en aditionnant chacune de leurs quantités et on la met à jour
  // ================================================================================================================
  $(document.body).on('updated_cart_totals', () => {

    if (!$('.woocommerce-cart-form').get(0)) return;

    const cart_quantity = $('.cart_item .product-quantity .qty').toArray().reduce((carry, item_quantity_input) => carry + parseInt(item_quantity_input.value), 0);
    if (typeof cart_quantity === 'number') {
      ff_update_cart_quantity(cart_quantity);
    }

    // On rajoute la classe "cta" au bouton de modification d'adresse du Poste Canada et le rénitialise
    $('.shipping-calculator-button').addClass('cta');
    $('.cta:not(.cta--instanciated)').each((i, cta_element) => {
      modules.FF_CTA.create(cta_element);
    });

  });

  $(document.body).on('updated_checkout', () => {
    modules.FF_CTA.create($('#place_order'));
  });

  // ================================================================================================================
  // Lors de la mise à jour de la page de paiement, on applique les classes de pair/impair sur les .form-row visibles des formulaires de facturation et de livraison
  // ================================================================================================================
  const update_checkout_forms_rows = () => {
    $('.woocommerce-billing-fields, .woocommerce-shipping-fields').each((i, form_element) => {
      $(form_element).find('.form-row.form-row-odd, .form-row.form-row-even').removeClass('form-row-odd form-row-even');
      $(form_element).find('.form-row:visible').addClass((form_row_i) => (form_row_i % 2 ? 'form-row-even' : 'form-row-odd'));
    });
  };
  update_checkout_forms_rows();

  $(document.body).on('init_checkout', update_checkout_forms_rows);
  $(document.body).on('update_checkout', () => {
    setTimeout(update_checkout_forms_rows);
  });

  // ================================================================================================================
  // Lorsque le panier est vidé
  // ================================================================================================================
  $(document.body).on('wc_cart_emptied', () => {

    // Mise à jour de la quantité du panier pour 0
    ff_update_cart_quantity(0);

    // On met la classe de panier vide sur le body
    $('body').addClass('woocommerce-cart-empty');

    // On rajoute la classe "cta" au bouton de retour à la boutique
    $('.return-to-shop a.button').addClass('cta');
    $('.cta:not(.cta--instanciated)').each((i, cta_element) => {
      modules.FF_CTA.create(cta_element);
    });

  });

  // ================================================================================================================
  // Au choix du pays d'expédition, on réinitialise les Select pour Selectric
  // ================================================================================================================
  $(document.body).on('country_to_state_changed', () => {
    // https://gist.github.com/Tusko/4168750ebbdf34fd2601b646932be008
    $('.selectric-wrapper').each(function () {
      const s = $('select', $(this));
      const selectric_instance = s.data('selectric');
      if ($('input.input-text', $(this)).length > 0) {
        $('input.input-text', $(this))
          .clone()
          .appendTo($(this).closest('.form-row'))
          .removeAttr('placeholder');
        $(this).remove();
      }
      if (typeof selectric_instance !== 'undefined') {
        selectric_instance.refresh();
      }
    });
    $('select').each(function () {
      if ($(this).data('selectric') !== 'undefined') {
        ff_init_selectric_element(this);
      }
    });
  });

  // ================================================================================================================
  // Mise à jour, au resize, des éléments en sticky centrés dans l'écran
  // ================================================================================================================
  $(window).on('resize', $.debounce(() => {
    ff_update_centered_sticky_elements();
  }, 200));

  // ================================================================================================================
  // Ajout de l'écouteur du hover du soleil de l'introduction de la page d'accueil
  // ================================================================================================================
  $('body').on('mouseenter', '.home-introduction__sun', (e) => {
    const $section = $(e.currentTarget).closest('.home-introduction');
    $section.addClass('home-introduction--sunset');
  });
  $('body').on('mouseleave', '.home-introduction__sun', (e) => {
    const $section = $(e.currentTarget).closest('.home-introduction');
    $section.removeClass('home-introduction--sunset');
  });

  // ================================================================================================================
  // Ajout de l'écouteur eu hover des "parts" du logo dans l'entête
  // ================================================================================================================
  if (!limit_animations) {
    $('body').on('mouseenter', '.header__logo-part', (e) => {

      const logo_part = e.currentTarget;
      if ($(logo_part).hasClass('header__logo-part--hover-animated') || $('.screen-menu').hasClass('screen-menu--is-closing')) return;

      const tl = gsap.timeline({
        onStart   : () => $(logo_part).addClass('header__logo-part--hover-animated'),
        onComplete: () => $(logo_part).removeClass('header__logo-part--hover-animated')
      });
      const logo_part_height = parseFloat($('svg', logo_part).attr('height'));
      tl.set($('.logo-letter', logo_part), { transition: 'none' });
      tl.to($('svg > .logo-letter', logo_part), { y: -logo_part_height * 1.05, duration: 0.7, ease: CustomEase.create('custom', 'M0,0 C0.073,0 0.126,0.033 0.187,0.089 0.277,0.17 0.313,0.304 0.361,0.512 0.419,0.768 0.457,0.865 0.555,0.93 0.631,0.98 0.849,1 1,1 '), stagger: { each: 0.05, from: $(logo_part).is(':first-child') ? 'end' : 'start' } }, 0);
      tl.to($('.logo-hover-group .logo-letter', logo_part), { y: 0, duration: 0.7, ease: CustomEase.create('custom', 'M0,0 C0.073,0 0.126,0.033 0.187,0.089 0.277,0.17 0.313,0.304 0.361,0.512 0.419,0.768 0.457,0.865 0.555,0.93 0.631,0.98 0.849,1 1,1 '), stagger: { each: 0.05, from: $(logo_part).is(':first-child') ? 'end' : 'start' } }, '<');
      tl.set($('.logo-letter', logo_part), { clearProps: 'y' });
      tl.set($('.logo-letter', logo_part), { clearProps: 'transition' });

    });
  }

  // ================================================================================================================
  // Ajout des écouteurs des liens de navigation du lobby de la médiathèque
  // ================================================================================================================
  if (!limit_animations && !is_touch_device) {
    $('body').on('mouseenter', '.articles-lobby__navigation-link', (e) => {
      const $section = $(e.currentTarget).closest('.articles-lobby');
      const $section_background = $section.find('.articles-lobby__bg');
      const type_link = $(e.currentTarget).attr('data-article-type');
      const $section_sun = $(`.articles-lobby__sun[data-article-type="${type_link}"]`);

      // On ajoute la classe
      $section_background.addClass(`article-type--${type_link}`);
      $section_sun.css('opacity', 1);

    });

    $('body').on('mouseleave', '.articles-lobby__navigation-link', (e) => {
      const $section = $(e.currentTarget).closest('.articles-lobby');
      const $section_background = $section.find('.articles-lobby__bg');
      const type_link = $(e.currentTarget).attr('data-article-type');
      const $section_sun = $(`.articles-lobby__sun[data-article-type="${type_link}"]`);

      // On retire la classse présente
      $section_background.removeClass(`article-type--${type_link}`);
      $section_sun.css('opacity', 0);

    });
  }

  // ================================================================================================================
  // En mobile, on ajoute un écouteur au resize pour refresh le ScrollTrigger de la barre de logo
  // ================================================================================================================
  if (is_mobile) {
    $(window).on('resize', $.throttle(() => {
      const scroll_trigger = ScrollTrigger.getById('header-logo-bar-offset');
      if (scroll_trigger) {
        scroll_trigger.refresh();
      }
    }, 200));
  }

  // ================================================================================================================
  // Sur téléphone, pour les h1 et h2, on applique on font-size selon le nombre de lettre du plus gros mot de l'élément
  // ================================================================================================================
  const update_phone_headings_font_size = () => {

    if (is_phone_display) {
      $('h1, h2, .u-h1, .u-h2').not('.prevent-resize').each((i, heading_ele) => {
        const words = $(heading_ele).text().split(/-| /);
        const longest_word_letters_count = words.reduce((acc, word) => Math.max(acc, word.length), 0);
        if (longest_word_letters_count > 10) {
          const new_font_size = Math.max(2, gsap.utils.mapRange(11, 18, 3.2, 2, longest_word_letters_count)); // *Valeur minimale de 2rem
          $(heading_ele)
            .css('fontSize', `${new_font_size}rem`)
            .addClass('js-heading-font-size-adjusted');
        }
      });
      return;
    }

    // Reset le font size des titres lorsque non en téléphone
    $('h1.js-heading-font-size-adjusted, h2.js-heading-font-size-adjusted, .u-h1.js-heading-font-size-adjusted, .u-h2.js-heading-font-size-adjusted')
      .css('fontSize', '')
      .removeClass('js-heading-font-size-adjusted');

  };

  // Mise à jour et ajout des écouteurs d'événement au changement de page et au resize
  update_phone_headings_font_size();
  $(window).on('resize', $.debounce(update_phone_headings_font_size, 500));
  barba.hooks.beforeEnter(update_phone_headings_font_size);

  // ================================================================================================================
  // Mise à jour  du font size des cartes de la médiathèque  et ajout des écouteurs d'événement au changement de page et au resize
  // ================================================================================================================
  ff_update_article_cards_titles_font_size();
  $(window).on('resize', $.debounce(ff_update_article_cards_titles_font_size, 500));
  barba.hooks.beforeEnter(ff_update_article_cards_titles_font_size);

  // ================================================================================================================
  // Calcul de certaines variables CSS
  // ================================================================================================================
  const calculate_css_properties = () => {
    document.documentElement.style.setProperty('--header_logo_container_height', `${$('.header__logo-container').innerHeight()}px`);
  };

  // Mise à jour et ajout des écouteurs d'événement au changement de page et au resize
  calculate_css_properties();
  $(window).on('resize', $.debounce(calculate_css_properties, 400));
  barba.hooks.beforeEnter(calculate_css_properties);

});


/***
*    ##        #######     ###    ########     ####    ##    #######  ##    ##    ########     ###    ########    ###
*    ##       ##     ##   ## ##   ##     ##     ##   ####   ##     ## ###   ##    ##     ##   ## ##      ##      ## ##
*    ##       ##     ##  ##   ##  ##     ##     ##     ##   ##     ## ####  ##    ##     ##  ##   ##     ##     ##   ##
*    ##       ##     ## ##     ## ##     ##     ##     ##    #######  ## ## ##    ##     ## ##     ##    ##    ##     ##
*    ##       ##     ## ######### ##     ##     ##     ##   ##     ## ##  ####    ##     ## #########    ##    #########
*    ##       ##     ## ##     ## ##     ##     ##     ##   ##     ## ##   ###    ##     ## ##     ##    ##    ##     ##
*    ########  #######  ##     ## ########     ####  ######  #######  ##    ##    ########  ##     ##    ##    ##     ##
*/
/**
 * Si nécéssaire, charge les traductions de chaînes pour le fichier actuel.
 *
 * @returns {Promise} Promise renvoyé après le chargement du fichier JSON des traductions.
 */
function ff_load_i18n_data() {
  return new Promise((resolve) => {

    if (!ff_is_multilingual_site) {
      resolve();
      return;
    }

    if (ff_locale == 'fr-FR') {
      wp.i18n.resetLocaleData({}, 'fatfish');
      resolve();
      return;
    }

    const i18n_json_file = `${ff_theme_url}languages/${ff_locale.replace('-', '_')}-${ff_i18n_frontend_js_file_hash}.json`;
    $.getJSON(i18n_json_file, (data) => {
      if (ff_locale.replace('-', '_') === data.locale_data.fatfish[''].lang) {
        wp.i18n.setLocaleData(data.locale_data.fatfish, 'fatfish');
      }
    }).always(() => resolve());

  });
}


/***
*    ##     ## ########  ########     ###    ######## ########    ########  ########   #######  ########         ########  ######## ##     ##
*    ##     ## ##     ## ##     ##   ## ##      ##    ##          ##     ## ##     ## ##     ## ##     ##        ##     ## ##       ###   ###
*    ##     ## ##     ## ##     ##  ##   ##     ##    ##          ##     ## ##     ## ##     ## ##     ##        ##     ## ##       #### ####
*    ##     ## ########  ##     ## ##     ##    ##    ######      ########  ########  ##     ## ########         ########  ######   ## ### ##
*    ##     ## ##        ##     ## #########    ##    ##          ##        ##   ##   ##     ## ##               ##   ##   ##       ##     ##
*    ##     ## ##        ##     ## ##     ##    ##    ##          ##        ##    ##  ##     ## ##        ###    ##    ##  ##       ##     ##
*     #######  ##        ########  ##     ##    ##    ########    ##        ##     ##  #######  ##        ###    ##     ## ######## ##     ##
*/
/**
 * Met à jour le la propriété CSS "font-size" à l'élément <html> calculée en fonction de la largeur de la fenêtre. Ceci nous permet d'utilisé le "rem" de manière proportionnelle.
 */
function ff_update_proportional_rem() {

  if (!ff_device_data) return;

  // ========================================================
  // Ajuste le font-size du HTML pour avoir nos polices proportionnelles
  // ========================================================
  let base;

  // Desktop
  if (is_desktop_display) {
    base = 13.5;
    rem = vw / (1440 / base);
    if (rem > 22) {
      rem = 22;
    }
    else if (rem < 12) {
      rem = 12;
    }
  }
  // Tablette
  else if (is_tablet_display) {
    base = 16;
    rem = vw / (1024 / base);
    if (rem < 12.5) {
      rem = 12.5;
    }
  }
  // Mobile
  else {
    base = 14.5;
    rem = vw / (390 / base);
    if (rem < 12) {
      rem = 12;
    }
  }

  // Mise à jour du font-size du HTML et la variable CSS de proportion
  $('html').css('font-size', `${rem}px`);
  document.documentElement.style.setProperty('--root_font_size_prop', rem / base);

}

/***
*    ##     ## ########  ########     ###    ######## ########    ########  ####  ######  ########  ##          ###    ##    ##    ##     ##    ###    ########   ######
*    ##     ## ##     ## ##     ##   ## ##      ##    ##          ##     ##  ##  ##    ## ##     ## ##         ## ##    ##  ##     ##     ##   ## ##   ##     ## ##    ##
*    ##     ## ##     ## ##     ##  ##   ##     ##    ##          ##     ##  ##  ##       ##     ## ##        ##   ##    ####      ##     ##  ##   ##  ##     ## ##
*    ##     ## ########  ##     ## ##     ##    ##    ######      ##     ##  ##   ######  ########  ##       ##     ##    ##       ##     ## ##     ## ########   ######
*    ##     ## ##        ##     ## #########    ##    ##          ##     ##  ##        ## ##        ##       #########    ##        ##   ##  ######### ##   ##         ##
*    ##     ## ##        ##     ## ##     ##    ##    ##          ##     ##  ##  ##    ## ##        ##       ##     ##    ##         ## ##   ##     ## ##    ##  ##    ##
*     #######  ##        ########  ##     ##    ##    ########    ########  ####  ######  ##        ######## ##     ##    ##          ###    ##     ## ##     ##  ######
*/
/**
 * Met à jour les différentes variables d'affichage utilisées dans les scripts du thème.
 */
function ff_update_display_vars() {

  // ================================================================================================================
  // Variables CSS
  // ================================================================================================================
  document.documentElement.style.setProperty('--dynamic_viewport_height', `${window.innerHeight}px`); // Variable CSS de la hauteur du viewport

  // ================================================================================================================
  // Variables JS
  // ================================================================================================================
  vw = window.innerWidth;
  vh = window.innerHeight;
}

/***
*    ######## #### ##     ##    ##     ## ##     ##
*    ##        ##   ##   ##     ##     ## ##     ##
*    ##        ##    ## ##      ##     ## ##     ##
*    ######    ##     ###       ##     ## #########
*    ##        ##    ## ##       ##   ##  ##     ##
*    ##        ##   ##   ##       ## ##   ##     ##
*    ##       #### ##     ##       ###    ##     ##
*/
/**
 * En mobile, calcule la valeur de la variable CSS "--vh" selon la hauteur du viewport sans les barres de navigation.
 */
function ff_fix_vh() {
  if (is_mobile) {
    const vh_css_var = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh_css_var}px`);
  }
}


/***
*     ######  ######## ######## ##     ## ########      ######    ######     ###    ########      ######   ######  ########   #######  ##       ##          ######## ########  ####  ######    ######   ######## ########
*    ##    ## ##          ##    ##     ## ##     ##    ##    ##  ##    ##   ## ##   ##     ##    ##    ## ##    ## ##     ## ##     ## ##       ##             ##    ##     ##  ##  ##    ##  ##    ##  ##       ##     ##
*    ##       ##          ##    ##     ## ##     ##    ##        ##        ##   ##  ##     ##    ##       ##       ##     ## ##     ## ##       ##             ##    ##     ##  ##  ##        ##        ##       ##     ##
*     ######  ######      ##    ##     ## ########     ##   ####  ######  ##     ## ########      ######  ##       ########  ##     ## ##       ##             ##    ########   ##  ##   #### ##   #### ######   ########
*          ## ##          ##    ##     ## ##           ##    ##        ## ######### ##                 ## ##       ##   ##   ##     ## ##       ##             ##    ##   ##    ##  ##    ##  ##    ##  ##       ##   ##
*    ##    ## ##          ##    ##     ## ##           ##    ##  ##    ## ##     ## ##           ##    ## ##    ## ##    ##  ##     ## ##       ##             ##    ##    ##   ##  ##    ##  ##    ##  ##       ##    ##
*     ######  ########    ##     #######  ##            ######    ######  ##     ## ##            ######   ######  ##     ##  #######  ######## ########       ##    ##     ## ####  ######    ######   ######## ##     ##
*/
/**
 * Inscrit le plugin ScrollTrigger pour GSAP. Si le défilement virtuel de FFScroll est activée sur la page, modifie le fonctionnement du plugin ScrollTrigger de GSAP pour qu'il fonctionne avec le défilement virtuel.
 */
function ff_setup_gsap_scroll_trigger() {

  // ==============================================================================================
  // Config de ScrollTrigger
  // ==============================================================================================
  ScrollTrigger.config({
    autoRefreshEvents: 'visibilitychange'
  });

  // ==============================================================================================
  // Au resize, après un debounce, rafraîchit toutes les instances de ScrollTrigger
  // ==============================================================================================
  let old_st_vw = vw;
  $(window).on('resize', $.debounce(() => {
    if (!is_mobile || old_st_vw !== vw) { // En mobile, on s'assure que le resize n'est pas un resize de hauteur déclenché par la barre de navigation
      ScrollTrigger.refresh();
    }
    old_st_vw = vw;
  }, 400));

  // ==============================================================================================
  // Bail si le défilement virtuel de FFScroll n'est pas activé
  // ==============================================================================================
  if (!ff_scroll || !ff_scroll.lenis.virtualScroll) {
    return;
  }
  const lenis_instance = ff_scroll.lenis;

  // ==============================================================================================
  // Changement des paramètres par défaut pour accomoder le scroll virtuel
  // ==============================================================================================
  ScrollTrigger.defaults({
    pinType: 'transform'
  });

  // ==============================================================================================
  // Mets à jour les marqueurs (s'il en a) lors du scroll
  // ==============================================================================================
  lenis_instance.on('scroll', ({ scroll }) => {
    const markers = gsap.utils.toArray('[class *= "gsap-marker-scroller"]');
    if (markers && markers.length !== 0) {
      gsap.set(markers, { marginTop: -scroll });
    }
  });
}


/***
*    #### ##    ## #### ########    ########  ########  ######  ########   #######  ##    ##  ######  #### ##     ## ########    ########  #######   #######  ##
*     ##  ###   ##  ##     ##       ##     ## ##       ##    ## ##     ## ##     ## ###   ## ##    ##  ##  ##     ## ##             ##    ##     ## ##     ## ##
*     ##  ####  ##  ##     ##       ##     ## ##       ##       ##     ## ##     ## ####  ## ##        ##  ##     ## ##             ##    ##     ## ##     ## ##
*     ##  ## ## ##  ##     ##       ########  ######    ######  ########  ##     ## ## ## ##  ######   ##  ##     ## ######         ##    ##     ## ##     ## ##
*     ##  ##  ####  ##     ##       ##   ##   ##             ## ##        ##     ## ##  ####       ##  ##   ##   ##  ##             ##    ##     ## ##     ## ##
*     ##  ##   ###  ##     ##       ##    ##  ##       ##    ## ##        ##     ## ##   ### ##    ##  ##    ## ##   ##             ##    ##     ## ##     ## ##
*    #### ##    ## ####    ##       ##     ## ########  ######  ##         #######  ##    ##  ######  ####    ###    ########       ##     #######   #######  ########
*/
/**
 * Initialise les outils de référence pour notre système de REM proportionnel (Peut être supprimée lorsque le développement est terminé).
 */
function ff_init_responsive_rem_tool() {

  // ===========================================================================
  // Bail si la variable "rem" n'a pas de valeur
  // ===========================================================================
  if (!rem) {
    return;
  }

  // ===========================================================================
  // Fonction qui met à jour l'outil
  // ===========================================================================
  const update_tools = () => {
    $('.responsive-rem-tool').each((index, element) => {
      $(element).find('.html-font-size-display span').html(parseFloat(rem.toFixed(3)));
      $(element).find('.example-tag').each(function () {
        const element_font_size = parseFloat($(this).css('font-size'));
        $(this).find('span').html(parseFloat(element_font_size.toFixed(3)));
        $(this).find('small').html(`(${parseFloat((element_font_size / rem).toFixed(3))}rem)`);
      });
    });
  };

  // ===========================================================================
  // Appel de "update_tools" maintenant, lors des changement de page et lors du resize de la page
  // ===========================================================================
  update_tools();
  if (barba) {
    barba.hooks.beforeEnter(update_tools);
  }
  $(window).on('resize', update_tools);

}

/***
*    #### ##    ## #### ########     ######  ######## ##       ########  ######  ######## ########  ####  ######     ######## ##       ######## ##     ## ######## ##    ## ########  ######
*     ##  ###   ##  ##     ##       ##    ## ##       ##       ##       ##    ##    ##    ##     ##  ##  ##    ##    ##       ##       ##       ###   ### ##       ###   ##    ##    ##    ##
*     ##  ####  ##  ##     ##       ##       ##       ##       ##       ##          ##    ##     ##  ##  ##          ##       ##       ##       #### #### ##       ####  ##    ##    ##
*     ##  ## ## ##  ##     ##        ######  ######   ##       ######   ##          ##    ########   ##  ##          ######   ##       ######   ## ### ## ######   ## ## ##    ##     ######
*     ##  ##  ####  ##     ##             ## ##       ##       ##       ##          ##    ##   ##    ##  ##          ##       ##       ##       ##     ## ##       ##  ####    ##          ##
*     ##  ##   ###  ##     ##       ##    ## ##       ##       ##       ##    ##    ##    ##    ##   ##  ##    ##    ##       ##       ##       ##     ## ##       ##   ###    ##    ##    ##
*    #### ##    ## ####    ##        ######  ######## ######## ########  ######     ##    ##     ## ####  ######     ######## ######## ######## ##     ## ######## ##    ##    ##     ######
*/
/**
 * Initialise tous les éléments <select> Selectric sur la page courante qui possède la classe "selectric".
 */
function ff_init_selectric_elements() {
  $('select.selectric').each((index, element) => ff_init_selectric_element(element));
}

/** *
 *     # #    # # #####     ####  ###### #      ######  ####  ##### #####  #  ####     ###### #      ###### #    # ###### #    # #####
 *     # ##   # #   #      #      #      #      #      #    #   #   #    # # #    #    #      #      #      ##  ## #      ##   #   #
 *     # # #  # #   #       ####  #####  #      #####  #        #   #    # # #         #####  #      #####  # ## # #####  # #  #   #
 *     # #  # # #   #           # #      #      #      #        #   #####  # #         #      #      #      #    # #      #  # #   #
 *     # #    # #   #       ####  ###### ###### ######  ####    #   #    # #  ####     ###### ###### ###### #    # ###### #    #   #.
 */
/**
 * Initialise une instance de sélecteur Selectric avec un élément donné en paramètre.
 *
 * @param {HTMLElement} element Élément à transformer en sélecteur Selectric.
 */
window.ff_init_selectric_element = (element) => {

  // ============================================================
  // Bail si la bibliothèque de Selectric n'est pas incluse
  // ============================================================
  if (!$.prototype.selectric || typeof $.prototype.selectric !== 'function') {
    console.warn('La bibliothèque jQuery Selectric n\'est pas incluse, donc les instances Selectric ne peuvent pas être crées. La bibliothèque est disponible au https://selectric.js.org/.');
    return;
  }


  // ============================================================
  // Fonction qui formatte le label du de l'élément à l'initialisation et au changement de valeur
  // ============================================================
  // Variable qui détermine si on formate ou non le label
  let allow_formatting = false;

  const format_select_label = function (select_element) {
    const label = select_element.closest('.selectric-wrapper').querySelector('.label');
    const options = select_element.options;

    if (!select_element.multiple) {
      const current_option = options.selectedIndex;
      if (current_option !== 0) {
        const text = `${options[0].innerText} : ${options[current_option].innerText}`;
        label.textContent = text;
      }
    }
    else {
      const vals = $(select_element).val();
      if (vals.length > 0) {
        const selected_options_labels = Array.from(options).filter((option) => vals.includes($(option).attr('value'))).map((option) => option.innerText);
        const text = `${options[0].innerText} : ${selected_options_labels.join(', ')}`;
        label.textContent = text;
      }
    }
  };

  // ============================================================
  // Initialisation
  // ============================================================
  $(element).addClass('selectric--instanciated');
  $(element).selectric({
    arrowButtonMarkup: `<b class="button">${$('#global-references .chevron-icon').get(0).outerHTML}</b>`,
    maxHeight        : 350,
    nativeOnMobile   : true,
    onInit           : function (event, selectric) { // Ajout d'une classes d'état sur l'élément selectric lorsque l'option par défaut est selectionné

      // Ajoute le data de FFScroll qui permet de scroll dans les items
      selectric.elements.itemsScroll.attr('data-lenis-prevent', '');

      // Si placeholder et select multiple, on formatte le label
      if (selectric.$li.filter('.disabled:not(:only-child)').length && selectric.state.multiple) allow_formatting = true;

      if ($(this).val() == '') $(this).closest('.selectric-wrapper').addClass('selectric-empty-option-selected');
      if (selectric.state.multiple) { // Cache l'option par défaut du <select> pour les <select> avec multiple selections
        selectric.$li.filter('.disabled:not(:only-child)').css('display', 'none');
      }
      selectric.element.selectric_instance = selectric;
      if (allow_formatting) format_select_label(selectric.element);

    },
    onOpen            : () => ff_scroll.update_lenis_prevent_elements(),
    optionsItemBuilder: function (item_data) { // Pour chaque <option>, s'il a un label, on l'utilise comme texte
      return item_data.element.attr('label') ? item_data.element.attr('label') : item_data.text;
    }
  }).on('change', function (e) { // Ajout ou retrait d'une classes d'état sur l'élément selectric lorsque l'option par défaut est selectionné
    if ($(this).val() == '') {
      $(this).closest('.selectric-wrapper').addClass('selectric-empty-option-selected');
    }
    else if ($(this).closest('.selectric-wrapper').hasClass('selectric-empty-option-selected')) {
      $(this).closest('.selectric-wrapper').removeClass('selectric-empty-option-selected');
    }
    if (allow_formatting) format_select_label(e.target);
  });

  // Ce champ est caché mais les analyses d'accessibilité le flag, donc on rajoute un aria-label générique
  $('.selectric-input')
    .attr('aria-label', 'Option')
    .attr('readonly', '');

};

/***
*    #### ##    ## #### ########    ######## ########     ######  ##       #### ########  ######## ########   ######
*     ##  ###   ##  ##     ##       ##       ##          ##    ## ##        ##  ##     ## ##       ##     ## ##    ##
*     ##  ####  ##  ##     ##       ##       ##          ##       ##        ##  ##     ## ##       ##     ## ##
*     ##  ## ## ##  ##     ##       ######   ######       ######  ##        ##  ##     ## ######   ########   ######
*     ##  ##  ####  ##     ##       ##       ##                ## ##        ##  ##     ## ##       ##   ##         ##
*     ##  ##   ###  ##     ##       ##       ##          ##    ## ##        ##  ##     ## ##       ##    ##  ##    ##
*    #### ##    ## ####    ##       ##       ##           ######  ######## #### ########  ######## ##     ##  ######
*/
/**
 * Initialise tous les FFSliders sur la page courante qui possède la classe "FFSlider".
 */
function ff_init_ff_sliders() {
  return new Promise(async (resolve) => {

    // =========================================================================
    // Réinitialisation des sliders déjà présent
    // =========================================================================
    ff_sliders.forEach((slider) => slider.clearAutoplay());
    ff_sliders = [];

    // ================================================================================================================
    // Bail, s'il n'y a pas d'éléments FFSlider
    // ================================================================================================================
    const $ff_sliders_elements = $('.FFSlider');
    if ($ff_sliders_elements.length == 0) {
      resolve();
      return;
    }

    // ================================================================================================================
    // Initialisation
    // ================================================================================================================
    // Si les scripts de FFSlider ou de Plyr ne sont pas chargés, on attend leurs chargements
    const ressources_promise = [];
    if (typeof FFSlider !== 'function') {
      ressources_promise.push(new Promise((script_load_resolve) => $('#ff-slider-js').on('load', script_load_resolve))); // eslint-disable-line no-promise-executor-return
    }
    if ($ff_sliders_elements.find('.plyr').get(0) && typeof Plyr !== 'function') { // Si un lecteur Plyr est présent dans un slider, on charge le script de Plyr
      ressources_promise.push(new Promise((script_load_resolve) => $('#ff-plyr-js').on('load', script_load_resolve))); // eslint-disable-line no-promise-executor-return
    }
    await Promise.all(ressources_promise);

    // Instanciation des FFSlider
    $ff_sliders_elements.each((i, slider_element) => {
      ff_init_ff_slider(slider_element);
    });
    resolve();

  });

}

/** *
 *     # #    # # #####    ###### ######     ####  #      # #####  ###### #####
 *     # ##   # #   #      #      #         #      #      # #    # #      #    #
 *     # # #  # #   #      #####  #####      ####  #      # #    # #####  #    #
 *     # #  # # #   #      #      #              # #      # #    # #      #####
 *     # #    # #   #      #      #          ####  ###### # #####  ###### #    #.
 */
/**
 * Initialise un FFSlider en donnant un élément à transformer en paramètre.
 *
 * @param {HTMLElement} element Element qui doit être transformé en slider.
 * @returns {object|boolean} Instance du FFSlider.
 */
function ff_init_ff_slider(element) {

  // ===========================================================================================
  // Bail si le module FFSlider n'est pas inclut
  // ===========================================================================================
  if (typeof FFSlider !== 'function') {
    console.warn('Le module FFSlider n\'est pas inclut, donc les instances FFSlider ne peuvent pas être crées. Le module est disponible au https://fatfishdev.com/ffhub/routes/js-plugins/ffslider/src/dist/js/FFSlider.min.js.');
    return false;
  }

  // ===========================================================================================
  // Bail si seulement une seule slide est présente
  // ===========================================================================================
  if ($(element).find('.element').length <= 1) {
    return false;
  }

  // ===========================================================================================
  // Hooks
  // ===========================================================================================
  const hooks = {

    // Lors de l'ajout d'une slide, si la slide ajoutée contient des éléments Plyr, on instancie les lecteurs
    after_slide_added: (data) => {
      const plyr_elements = $(data.slide_added).find('.plyr');
      if (plyr_elements.length > 0) {
        plyr_elements.each((i, plyr_element) => {
          ff_init_plyr_player(plyr_element);
        });
      }
    },

    // Lors du retrait d'une slide, retire les instances de lecteur Plyr présentes dans la slide supprimée du tableau global des lecteur
    before_slide_removed: (data) => {
      const plyr_elements = $(data.slide_removed).find('.plyr');
      if (plyr_elements.length > 0) {
        plyr_elements.each((i, plyr_element) => {
          plyr_player_to_remove_index = plyr_players.findIndex((player) => player.elements.container === plyr_element);
          if (plyr_player_to_remove_index) {
            plyr_players.splice(plyr_player_to_remove_index, 1);
          }
        });
      }
    },

    after_init: () => {
      ScrollTrigger.refresh();
    }

  };

  // ===========================================================================================
  // Options pour le slider
  // ===========================================================================================
  const options = {
    loop             : true,
    easing           : CustomEase.create('custom', 'M0,0 C0.16,0 0.228,0.054 0.274,0.118 0.336,0.205 0.404,0.36 0.438,0.502 0.466,0.62 0.518,0.802 0.598,0.888 0.664,0.959 0.672,1 1,1 '),
    speed            : $(element).hasClass('home-featured-content__slider') ? 1400 : 1200,
    keyboard_controls: true,
    show_thumbnails  : true,
    autoplay         : {
      stop_on_interaction: true,
      delay              : 5000
    },
    ...hooks
  };

  // Transition de la couleur de l'arrière-plan et animation custom de ".home-featured-content" lors du changement de slide
  if ($(element).hasClass('home-featured-content__slider')) {
    const section = $(element).closest('.home-featured-content').get(0);
    let next_bg_color_index;

    options.before_slide_anim = ({ direction, next_active_slide }) => {
      next_bg_color_index = $(next_active_slide).find('.home-featured-content__slide-wrapper').attr('data-custom-bg-color') || 'default';
      // Animation custom
      gsap.fromTo(next_active_slide, { opacity: 0.5 }, { opacity: 1, ease: 'power4.out', duration: 1.3, delay: 0.5 });
      if (direction == 'next') {
        gsap.fromTo($(next_active_slide).find(is_phone_display ? '.home-featured-content__slide-image-container' : '.home-featured-content__slide-text-container'), { x: '24rem' }, { x: 0, ease: 'expo.out', duration: 1.3, delay: 0.5, clearProps: 'x,opacity' });
      }
      else if (direction == 'prev') {
        gsap.fromTo($(next_active_slide).find('.home-featured-content__slide-image-container'), { x: '-24rem' }, { x: 0, ease: 'expo.out', duration: 1.3, delay: 0.5, clearProps: 'x,opacity' });
      }

      // Couleur d'arrière-plan
      if ($('html').hasClass('barba-transitioning')) return;
      $(section).attr('data-page-bg-color', next_bg_color_index);
      ScrollTrigger.refresh();

    };
  }

  // Mise à jour du crédit photo du slider de la gallerie photo des auteurs
  if ($(element).hasClass('author-photos-gallery__slider')) {
    const $photo_credits_ele = $(element).closest('.author-photos-gallery').find('.author-photos-gallery__photo-credits');
    options.before_slide_anim = async ({ current_active_slide, next_active_slide }) => {
      const current_slide_photo_credits = $(current_active_slide).find('[data-photo-credits]').attr('data-photo-credits') || '';
      const next_slide_photo_credits = $(next_active_slide).find('[data-photo-credits]').attr('data-photo-credits') || '';
      if (current_slide_photo_credits !== next_slide_photo_credits) {
        gsap.killTweensOf($photo_credits_ele);
        await gsap.to($photo_credits_ele, { opacity: 0, [is_phone_display ? 'y' : 'x']: '1.6em', duration: 0.425, ease: 'power2.in', clearProps: 'y,x' });
        if (next_slide_photo_credits) {
          $photo_credits_ele.html(next_slide_photo_credits);
          gsap.to($photo_credits_ele, { opacity: 1, duration: 0.6, ease: 'custom.inOutSlowOut' });
          gsap.to($photo_credits_ele, { [is_phone_display ? 'y' : 'x']: 0, duration: 1.25, ease: 'power4.out', clearProps: 'y,x' });
        }
      }
    };
  }

  // Options pour le slider mobile du lobby de la médiathèque
  if ($(element).hasClass('articles-lobby__slider')) {
    options.slide_to_show = '1';
    options.autoplay = false;
    options.loop = true;
    options.draggable = true;
    // Chargements des premières couleurs en mobiles
    options.after_init = (data) => {
      if (is_phone_display) {
        const $section = $(data.current_active_slide).closest('.articles-lobby');
        const current_type_link = $(data.current_active_slide).find('[data-article-type]').attr('data-article-type');
        $section.find('.articles-lobby__bg').addClass(`article-type--${current_type_link}`);
        $(`.articles-lobby__sun[data-article-type="${current_type_link}"]`).css('opacity', 1);
      }
    };
    // Animation du background et du soleil au changement de diapo
    options.before_slide_anim = (data) => {
      const $section = $(data.current_active_slide).closest('.articles-lobby');
      const $section_background = $section.find('.articles-lobby__bg');

      const current_type_link = $(data.current_active_slide).find('[data-article-type]').attr('data-article-type');
      const $current_section_sun = $(`.articles-lobby__sun[data-article-type="${current_type_link}"]`);

      const next_type_link = $(data.next_active_slide).find('[data-article-type]').attr('data-article-type');
      const $next_section_sun = $(`.articles-lobby__sun[data-article-type="${next_type_link}"]`);

      // On retire les classes de la slide précédente
      $section_background.removeClass(`article-type--${current_type_link}`);
      $current_section_sun.css('opacity', 0);

      // et on ajoute les nouvelles classe
      $section_background.addClass(`article-type--${next_type_link}`);
      $next_section_sun.css('opacity', 1);
    };
  }


  // ===========================================================================================
  // Initialisation du slider
  // ===========================================================================================
  const slider = new FFSlider($(element), options);
  ff_sliders.push(slider);
  element.ff_slider_instance = slider; // Ajout de l'instance comme propriété à l'élément
  $(element).addClass('FFSlider--instanciated');

  // ===========================================================================================
  // Retour de l'instance
  // ===========================================================================================
  return slider;

}

/***
*    #### ##    ## #### ########    ######## ########     ######   ##       #### ########  ######## ########   ######
*     ##  ###   ##  ##     ##       ##       ##          ##    ##  ##        ##  ##     ## ##       ##     ## ##    ##
*     ##  ####  ##  ##     ##       ##       ##          ##        ##        ##  ##     ## ##       ##     ## ##
*     ##  ## ## ##  ##     ##       ######   ######      ##   #### ##        ##  ##     ## ######   ########   ######
*     ##  ##  ####  ##     ##       ##       ##          ##    ##  ##        ##  ##     ## ##       ##   ##         ##
*     ##  ##   ###  ##     ##       ##       ##          ##    ##  ##        ##  ##     ## ##       ##    ##  ##    ##
*    #### ##    ## ####    ##       ##       ##           ######   ######## #### ########  ######## ##     ##  ######
*/
/**
 * Initialise tous les FFGliders sur la page courante qui possède la classe "ffglider".
 */
function ff_init_ff_gliders() {
  ff_gliders = []; // Réinitialisation des gliders déjà présent
  $('.ffglider:not(.ffglider--no-auto-instanciation)').each((index, element) => { // eslint-disable-line consistent-return
    if ($(element).find('.item').length <= 1) return true;
    ff_init_ff_glider(element);
  });
}

/** *
 *     # #    # # #####    ###### ######     ####  #      # #####  ###### #####
 *     # ##   # #   #      #      #         #    # #      # #    # #      #    #
 *     # # #  # #   #      #####  #####     #      #      # #    # #####  #    #
 *     # #  # # #   #      #      #         #  ### #      # #    # #      #####
 *     # #    # #   #      #      #          ####  ###### # #####  ###### #    #.
 */
/**
 * Initialise un FFGlider en donnant un élément à transformer en paramètre.
 *
 * @param {HTMLElement} element Élement qui doit être transformé en glider.
 * @param {object} [options={}] Options du FFGlider. (Optionnel).
 * @returns {object} Instance du FFGlider.
 */
function ff_init_ff_glider(element, options = {}) {

  // ============================================================
  // Bail si le module FFSlider n'est pas inclut
  // ============================================================
  if (typeof FFGlider !== 'function') {
    console.warn('Le module FFGlider n\'est pas inclut, donc les instances FFGlider ne peuvent pas être crées. Le module est disponible au https://fatfishdev.com/ffhub/routes/js-plugins/ffglider/src/dist/js/ffglider.min.js.');
    return false;
  }

  // ===========================================================================================
  // Options par défaut pour le glider
  // ===========================================================================================
  const default_options = {};

  // Merge des options
  options = ff_merge_objects(default_options, options);

  // ===========================================================================================
  // Initialisation du glider
  // ===========================================================================================
  const element_id = `#${element.id}`;
  const glider = new FFGlider(element_id, options);
  $(element).addClass('ffglider--instanciated');
  ff_gliders.push(glider);
  element.ff_glider_instance = glider; // Ajout de l'instance comme propriété à l'élément
  glider.handleResize();


  // ===========================================================================================
  // Calcul de la hauteur du glider selon la hauteur de l'item le plus haut
  // ===========================================================================================
  if (typeof glider.glider_items[0] !== 'undefined') {
    const calculate_glider_items_height = () => {
      const height = Array.from(glider.glider_items).reduce((highest_height, item) => {
        const item_height = $(item).innerHeight();
        return item_height > highest_height ? item_height : highest_height;
      }, 0);
      glider.glider.style.setProperty('--ff-glider-items-height', `${height}px`);
    };
    $(window).on('resize', $.debounce(calculate_glider_items_height, 200));
    calculate_glider_items_height();
  }

  // ===========================================================================================
  // Retour de l'instance
  // ===========================================================================================
  return glider;

}


/***
*    #### ##    ## #### ########    ########  ##       ##    ## ########     ########  ##          ###    ##    ## ######## ########   ######
*     ##  ###   ##  ##     ##       ##     ## ##        ##  ##  ##     ##    ##     ## ##         ## ##    ##  ##  ##       ##     ## ##    ##
*     ##  ####  ##  ##     ##       ##     ## ##         ####   ##     ##    ##     ## ##        ##   ##    ####   ##       ##     ## ##
*     ##  ## ## ##  ##     ##       ########  ##          ##    ########     ########  ##       ##     ##    ##    ######   ########   ######
*     ##  ##  ####  ##     ##       ##        ##          ##    ##   ##      ##        ##       #########    ##    ##       ##   ##         ##
*     ##  ##   ###  ##     ##       ##        ##          ##    ##    ##     ##        ##       ##     ##    ##    ##       ##    ##  ##    ##
*    #### ##    ## ####    ##       ##        ########    ##    ##     ##    ##        ######## ##     ##    ##    ######## ##     ##  ######
*/
/**
 * Initialise tous les lecteurs Plyr sur la page courante qui possède la classe "plyr".
 */
function ff_init_plyr_players() {
  return new Promise((resolve) => {

    const plyr_elements = $('.plyr');

    // ================================================================================================================
    // Bail, s'il n'y a pas d'éléments Plyr
    // ================================================================================================================
    if (plyr_elements.length == 0) {
      resolve();
      return;
    }

    // ================================================================================================================
    // Initialisation des lecteurs pour chaque éléments Plyr
    // ================================================================================================================
    plyr_players = [];

    // Si le script est déjà chargé
    if (typeof Plyr == 'function') {
      plyr_elements.each((i, plyr_element) => {
        ff_init_plyr_player(plyr_element);
      });
      resolve();
    }
    // Sinon on attend le chargement du script
    else {

      $('#ff-plyr-js').on('load', () => {
        plyr_elements.each((i, plyr_element) => {
          ff_init_plyr_player(plyr_element);
        });
        resolve();
      });
    }

  });
}

/** *
 *     # #    # # #####    #####  #      #   # #####     #####  #        ##   #   # ###### #####
 *     # ##   # #   #      #    # #       # #  #    #    #    # #       #  #   # #  #      #    #
 *     # # #  # #   #      #    # #        #   #    #    #    # #      #    #   #   #####  #    #
 *     # #  # # #   #      #####  #        #   #####     #####  #      ######   #   #      #####
 *     # #    # #   #      #      ######   #   #    #    #      ###### #    #   #   ###### #    #.
 */
/**
 * Initialise un lecteur Plyr.
 *
 * @param {HTMLElement} element Élément à transformer en lecteur Plyr.
 * @param {object} [options={}] Options pour le lecteur. (Paramètres de Plyr) (Optionnel).
 * @returns {object|boolean} Instance du lecteur Plyr.
 */
function ff_init_plyr_player(element, options) {

  // ============================================================
  // Bail si la bibliothèque Plyr n'est pas incluse
  // ============================================================
  if (typeof Plyr !== 'function') {
    console.warn('La bibliothèque Plyr n\'est pas incluse, donc les instances Plyr ne peuvent pas être crées. La bibliothèque est disponible au https://github.com/sampotts/plyr.');
    return false;
  }

  // =============================================================================================================
  // Variables
  // =============================================================================================================
  element = $(element).get(0);
  let player_options = {
    controls: (
      $(element).is('audio')
        ? ['play', 'progress', 'current-time', 'mute'] // Audio
        : ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] // Video
    )
  };
  let element_classes = '';
  if (element.classList) {
    element_classes = [...element.classList].filter((class_name) => class_name != 'plyr').join(' ');
  }

  // =============================================================================================================
  // Options
  // =============================================================================================================
  // On écrase les options du lecteurs spécifiés plus avec ceux donnés en paramètre
  player_options = { ...player_options, ...options };

  // =============================================================================================================
  // Initialisation du lecteur
  // =============================================================================================================
  const plyr_player = new Plyr(element, player_options);
  plyr_players.push(plyr_player);
  $(plyr_player.elements.container).addClass(element_classes); // Ajout des classes de l'élément original
  element.ff_plyr_instance = plyr_player; // Ajout de l'instance comme propriété à l'élément

  // =============================================================================================================
  // Ajout d'écouteurs lorsque le lecteur entre et sort du mode plein écran
  // =============================================================================================================
  plyr_player.on('enterfullscreen', (e) => {
    $(e.detail.plyr.elements.container).addClass('plyr--is-fullscreen-mode'); // Ajout d'une classe d'état de mode plein écran actif
  });

  plyr_player.on('exitfullscreen', (e) => {
    $(e.detail.plyr.elements.container).removeClass('plyr--is-fullscreen-mode'); // Retrait de la classe d'état de mode plein écran actif
  });

  // =============================================================================================================
  // Retourn de l'instance
  // =============================================================================================================
  return plyr_player;

}

/***
*    #### ##    ## #### ########     ######    #######   #######   ######   ##       ########    ##     ##    ###    ########   ######
*     ##  ###   ##  ##     ##       ##    ##  ##     ## ##     ## ##    ##  ##       ##          ###   ###   ## ##   ##     ## ##    ##
*     ##  ####  ##  ##     ##       ##        ##     ## ##     ## ##        ##       ##          #### ####  ##   ##  ##     ## ##
*     ##  ## ## ##  ##     ##       ##   #### ##     ## ##     ## ##   #### ##       ######      ## ### ## ##     ## ########   ######
*     ##  ##  ####  ##     ##       ##    ##  ##     ## ##     ## ##    ##  ##       ##          ##     ## ######### ##              ##
*     ##  ##   ###  ##     ##       ##    ##  ##     ## ##     ## ##    ##  ##       ##          ##     ## ##     ## ##        ##    ##
*    #### ##    ## ####    ##        ######    #######   #######   ######   ######## ########    ##     ## ##     ## ##         ######
*/
/**
 * Initialise toutes les cartes Google Maps sur la page courante qui possède la classe "google-map".
 */
async function ff_init_google_maps() {

  // =============================================================================================================
  // Réinitialisation du tableau global des cartes
  // =============================================================================================================
  google_maps = [];

  // =============================================================================================================
  // Initialisation des nouvelles cartes
  // =============================================================================================================
  const $google_map_elements = $('.google-map');
  if ($google_map_elements.length === 0) { // Bail s'il n'y a pas de cartes à initialiser
    return;
  }

  if (typeof google_api_key === 'undefined') { // Bail s'il n'y a pas de clé d'API
    console.error('La clé d\'API Google Maps n\'est pas fournie dans la page d\'options "Clés d\'API" Wordpress, alors les cartes ne peuvent pas être initialisées.');
    return;
  }

  // Si le script l'API JavaScript de Google Maps n'est pas encore chargé, on le charge et ensuite on initialise les cartes ----------------------------------------------------
  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    const google_maps_script = document.createElement('script');
    google_maps_script.id = 'google-maps-script';
    google_maps_script.src = `https://maps.googleapis.com/maps/api/js?key=${google_api_key}&callback=ff_init_maps`;
    google_maps_script.async = true;
    google_maps_script.defer = true;

    window.ff_init_maps = function () {
      $google_map_elements.each((index, element) => {
        ff_init_google_map(element);
      });
    };

    document.head.appendChild(google_maps_script);
  }

  // Sinon, on initialise les cartes immédiatement ----------------------------------------------------------------------------------------------------------------------------
  else {
    $google_map_elements.each((index, element) => {
      ff_init_google_map(element);
    });
  }

}

/** *
 *     # #    # # #####     ####   ####   ####   ####  #      ######    #    #   ##   #####
 *     # ##   # #   #      #    # #    # #    # #    # #      #         ##  ##  #  #  #    #
 *     # # #  # #   #      #      #    # #    # #      #      #####     # ## # #    # #    #
 *     # #  # # #   #      #  ### #    # #    # #  ### #      #         #    # ###### #####
 *     # #    # #   #       ####   ####   ####   ####  ###### ######    #    # #    # #.
 */
/**
 * Initialise un Carte Google en donnant un élément à transformer en paramètre.
 *
 * @param {HTMLElement} element Element qui doit être transformé en carte Google Maps.
 * @returns {Object|Boolean} Instance de carte Google Maps.
 */
function ff_init_google_map(element) {

  // ============================================================
  // Bail si la bibliothèque de l'API de Google Maps n'est pas incluse
  // ============================================================
  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    console.error('La bibliothèque de l\'API de Google Maps n\'est pas incluse, donc les instances de cartes Google Maps ne peuvent pas être crées. Il faut se référer à https://developers.google.com/maps/documentation/javascript/overview?hl=fr.');
    return false;
  }

  // ================================================================================================================
  // Options de la carte
  // ================================================================================================================
  let map_options = JSON.parse($(element).attr('data-map-options') || '{}');
  map_options = ff_merge_objects({
    zoom            : 12,
    disableDefaultUI: true,
    clickableIcons  : false
  }, map_options);

  // ================================================================================================================
  // Initialisation
  // ================================================================================================================
  const map = new google.maps.Map(element, map_options);
  const map_markers = [];
  const map_info_windows = [];
  google_maps.push(map);
  element.ff_google_map_instance = map; // Ajout de l'instance comme propriété à l'élément

  // ================================================================================================================
  // Styles de la carte
  // ================================================================================================================
  map.setOptions({
    styles: [
      {
        featureType: 'poi',
        stylers    : [{ visibility: 'off' }]
      },
      {
        featureType: 'transit',
        stylers    : [{ visibility: 'off' }]
      },
      {
        featureType: 'landscape',
        stylers    : [{ visibility: 'off' }]
      }
    ]
  });

  // ================================================================================================================
  // Marqueurs de la carte
  // ================================================================================================================
  const map_markers_attr = JSON.parse($(element).attr('data-map-markers') || '[]');
  const markers_bounds = new google.maps.LatLngBounds();

  map_markers_attr.forEach((marker_options) => {

    // Initialisation du marqueur ----------------------------------------------------------------------------------------------------
    marker_options = {
      ...marker_options,
      map: map
    };

    const marker = new google.maps.Marker(marker_options);
    map_markers.push(marker);
    markers_bounds.extend(marker.position);

    // Ajout la fenêtre d'information qui s'ouvre au clic du marqueur ---------------------------------------------------------------
    if (typeof marker_options.infoWindowOptions !== 'undefined' && typeof marker_options.infoWindowOptions.content !== 'undefined') {
      const marker_info_window = new google.maps.InfoWindow(marker_options.infoWindowOptions);
      map_info_windows.push(marker_info_window);

      // Au clic du marqueur, ouvre la fenêtre associée
      marker.addListener('click', () => {
        map_info_windows.filter((info_window) => info_window !== marker_info_window).forEach((info_window) => info_window.close()); // Ferme les autres fenêtres dans la carte
        marker_info_window.open(map, marker);
      });
    }

  });

  // ================================================================================================================
  // Si l'élément possède l'attribut "data-fit-markers-bounds", on ajuste le zoom et la position de la carte selon les marqueurs de la cartes
  // ================================================================================================================
  if (typeof $(element).attr('data-fit-markers-bounds') !== 'undefined' && !markers_bounds.isEmpty()) {
    map.setCenter(markers_bounds.getCenter());
    map.fitBounds(markers_bounds);
  }

  // ================================================================================================================
  // Retour de l'instance
  // ================================================================================================================
  return map;
}


/***
*       ###    ########  ########     ######## #### ##       ########    #### ##    ## ########  ##     ## ########  ######      ######  ######## ##    ## ##       ########
*      ## ##   ##     ## ##     ##    ##        ##  ##       ##           ##  ###   ## ##     ## ##     ##    ##    ##    ##    ##    ##    ##     ##  ##  ##       ##
*     ##   ##  ##     ## ##     ##    ##        ##  ##       ##           ##  ####  ## ##     ## ##     ##    ##    ##          ##          ##      ####   ##       ##
*    ##     ## ##     ## ##     ##    ######    ##  ##       ######       ##  ## ## ## ########  ##     ##    ##     ######      ######     ##       ##    ##       ######
*    ######### ##     ## ##     ##    ##        ##  ##       ##           ##  ##  #### ##        ##     ##    ##          ##          ##    ##       ##    ##       ##
*    ##     ## ##     ## ##     ##    ##        ##  ##       ##           ##  ##   ### ##        ##     ##    ##    ##    ##    ##    ##    ##       ##    ##       ##
*    ##     ## ########  ########     ##       #### ######## ########    #### ##    ## ##         #######     ##     ######      ######     ##       ##    ######## ########
*/
/**
 * Ajoute l'intéractivité qui met à jour le texte des champs de type "file" selon le contexte.
 */
function ff_add_file_inputs_interaction() { /* eslint-disable-line no-unused-vars */
  $('input[type="file"]').each(function () {

    const input_element = this;
    const input_id = $(input_element).attr('id');
    const linked_label_element = $(`.file-input-visual[for="${input_id}"].file-input-visual`).get(0);
    const linked_label_pill_button_element = $(linked_label_element).find('.pill-button').get(0);

    // Met à jour le text. Si un component ".pill-button" est trouvé dans le champ on remplace le texte de cet élément.
    const update_text = (text) => {
      if (linked_label_pill_button_element) {
        $(linked_label_pill_button_element).find('.pill-button__text').html(text);
      }
      else {
        $(linked_label_element).html(text);
      }
    };

    // ===============================================================================
    // Bail, si aucun label n'est associé au input
    // ===============================================================================
    if (!linked_label_element) {
      return;
    }

    // ===============================================================================
    // Bail, si le label associé manque un ou plusieurs attributs nécéssaires
    // ===============================================================================
    const linked_label_attributes = [];
    for (let i = 0; i < linked_label_element.attributes.length; i++) {
      linked_label_attributes.push(linked_label_element.attributes[i].nodeName);
    }
    const required_attributes = ['data-choose-file-text', 'data-no-file-text', 'data-file-plural-noun-text'];
    if (!required_attributes.every((attr) => linked_label_attributes.includes(attr))) {
      console.warn('Il semble manquer un ou plusieurs attributs au <label> associé afin d\'ajouter l\'interaction pour le champ de type "file". Il doit y avoir les attributs "data-choose-file-text", "data-no-file-text" et "data-file-plural-noun-text".');
      return;
    }

    // ===============================================================================
    // Si le label ne se trouve pas avant le input, on le replace pour le mettre à cette endroit
    // ===============================================================================
    if ($(input_element).prev().filter(linked_label_element).length === 0) {
      $(input_element).before(linked_label_element);
    }

    // ===============================================================================
    // Ajout du texte par défaut
    // ===============================================================================
    const texts = {
      choose_file     : $(linked_label_element).attr('data-choose-file-text'),
      no_file         : $(linked_label_element).attr('data-no-file-text'),
      file_plural_noun: $(linked_label_element).attr('data-file-plural-noun-text')
    };
    update_text(texts.choose_file);

    // ===============================================================================
    // Ajout de l'écouteur d'événement qui va changer le texte selon la situation
    // ===============================================================================
    $(input_element).on('change', function (e) {
      let new_text = '';
      if (this.files && this.files.length == 1) {
        new_text = e.target.value.split('\\').pop();
      }
      else if (this.files && this.files.length > 1) {
        new_text = `${this.files.length} ${texts.file_plural_noun}`;
      }
      else {
        new_text = texts.no_file;
      }
      update_text(new_text);
    });

    // ===============================================================================
    // Si le champ comporte un ".pill-button", on preventDefault() au clic et on trigger le clic sur le label parent
    // ===============================================================================
    if (linked_label_pill_button_element) {
      $(linked_label_pill_button_element).on('click', (e) => {
        e.preventDefault();
        $(linked_label_element).trigger('click');
      });
    }

  });
}


/***
 *       ###    ########  ########     ########  #######      ######     ###    ########  ########
 *      ## ##   ##     ## ##     ##       ##    ##     ##    ##    ##   ## ##   ##     ##    ##
 *     ##   ##  ##     ## ##     ##       ##    ##     ##    ##        ##   ##  ##     ##    ##
 *    ##     ## ##     ## ##     ##       ##    ##     ##    ##       ##     ## ########     ##
 *    ######### ##     ## ##     ##       ##    ##     ##    ##       ######### ##   ##      ##
 *    ##     ## ##     ## ##     ##       ##    ##     ##    ##    ## ##     ## ##    ##     ##
 *    ##     ## ########  ########        ##     #######      ######  ##     ## ##     ##    ##
 */
/**
 * Ajoute une variation de produit au panier en AJAX.
 * @param {Number} product_id ID du post du produit.
 * @param {Number} product_variation_id ID du post de la variation de produit.
 * @param {HTMLElement} trigger_element Élément cliqué pour l'ajout au panier. (Optionnel).
 */
function ff_add_to_cart(product_id, product_variation_id, trigger_element = null) {

  // Bail si on est déjà dans le processus d'ajouter un item au panier
  if ($('html').hasClass('is-adding-to-cart')) {
    return;
  }

  // Si le trigger_element est un '.add-to-cart-button', on ajoute l'état de chargement
  let pill_button_loading_state_add_promise;
  if ($(trigger_element).hasClass('add-to-cart-button') && typeof trigger_element.ff_module_instances.FF_Pill_Button !== 'undefined') {
    pill_button_loading_state_add_promise = trigger_element.ff_module_instances.FF_Pill_Button.add_loading_state();
  }

  // Désactivation des boutons d'ajout au paniers
  $('html').addClass('is-loading is-adding-to-cart');
  $('.add-to-cart-button').css('pointerEvents', 'none');

  // Appel AJAX
  ff_ajax({
    dataType: 'json',
    data    : {
      action: 'add-to-cart',
      product_id,
      product_variation_id
    },
    complete: async function () {

      // Réinitilise le bouton d'ajout au panier cliqué
      if ($(trigger_element).hasClass('add-to-cart-button') && typeof trigger_element.ff_module_instances.FF_Pill_Button !== 'undefined') {
        if (pill_button_loading_state_add_promise) {
          await pill_button_loading_state_add_promise;
        }
        await trigger_element.ff_module_instances.FF_Pill_Button.remove_loading_state();
      }

      // Retire les états de chargement
      $('html').removeClass('is-loading is-adding-to-cart');
      $('.add-to-cart-button').css('pointerEvents', '');

    },
    error: function (request, status, error) {
      console.error('AJAX ERROR');
      if (error) {
        console.error('Error:', error);
      }
      console.error('Request status code:', request.status, `https://developer.mozilla.org/fr/docs/Web/HTTP/Status/${request.status}`);
      console.error('Request response:', request.responseText);
    },
    success: function (json) {

      let notification_message = json.success ? __('L\'ouvrage a bien été ajouté au panier!', 'fatfish') : __('L\'ouvrage n\'a pas pu être ajouté au panier.', 'fatfish');

      // Si l'ajout est un succès, on met à jour le bouton de panier dans l'entête
      if (json.success && typeof json.data.cart_items_count !== 'undefined') {
        ff_update_cart_quantity(json.data.cart_items_count);
      }

      // Si c'est un échec, on essaie de retrouver la notice WC
      else if (typeof json.data.message !== 'undefined') {
        notification_message = json.data.message || notification_message;
      }

      // Affichage de la notification de panier selon le succès de l'ajout
      ff_show_cart_notification(notification_message);

    }
  });

}


/***
 *     ######  ##     ##  #######  ##      ##     ######     ###    ########  ########    ##    ##  #######  ######## #### ######## ####  ######     ###    ######## ####  #######  ##    ##
 *    ##    ## ##     ## ##     ## ##  ##  ##    ##    ##   ## ##   ##     ##    ##       ###   ## ##     ##    ##     ##  ##        ##  ##    ##   ## ##      ##     ##  ##     ## ###   ##
 *    ##       ##     ## ##     ## ##  ##  ##    ##        ##   ##  ##     ##    ##       ####  ## ##     ##    ##     ##  ##        ##  ##        ##   ##     ##     ##  ##     ## ####  ##
 *     ######  ######### ##     ## ##  ##  ##    ##       ##     ## ########     ##       ## ## ## ##     ##    ##     ##  ######    ##  ##       ##     ##    ##     ##  ##     ## ## ## ##
 *          ## ##     ## ##     ## ##  ##  ##    ##       ######### ##   ##      ##       ##  #### ##     ##    ##     ##  ##        ##  ##       #########    ##     ##  ##     ## ##  ####
 *    ##    ## ##     ## ##     ## ##  ##  ##    ##    ## ##     ## ##    ##     ##       ##   ### ##     ##    ##     ##  ##        ##  ##    ## ##     ##    ##     ##  ##     ## ##   ###
 *     ######  ##     ##  #######   ###  ###      ######  ##     ## ##     ##    ##       ##    ##  #######     ##    #### ##       ####  ######  ##     ##    ##    ####  #######  ##    ##
 */
/**
 * Affiche la notification de panier en fixed et la fait disparaître après un délai.
 * @param {String} message Message à afficher dans l'élément.
 */
function ff_show_cart_notification(message) {

  const $cart_notification = $('.cart-notification');
  $cart_notification.addClass('cart-notification--shown');
  $cart_notification.find('.cart-notification__message').html(message);

  const clear_timeout = () => {
    if (cart_notification_timeout) clearTimeout(cart_notification_timeout);
    cart_notification_timeout = null;
  };
  const set_timeout = () => {
    clear_timeout();
    cart_notification_timeout = setTimeout(() => {
      ff_hide_cart_notification();
      cart_notification_timeout = null;
    }, 4000);
  };


  // Affichage
  $cart_notification.removeAttr('aria-hidden');
  gsap.killTweensOf($cart_notification);
  gsap.set($cart_notification, { display: 'block' });
  gsap.to($cart_notification, { y: 0, duration: 0.9, ease: 'expo.out' });

  // Fermeture après 4 secondes
  set_timeout();

  // Lors du hover de l'élément, on cancel le timeout et, lors de la sorti du curseur, on le réactive
  $cart_notification.one('mouseenter', () => {
    clear_timeout();
    $cart_notification.one('mouseleave', set_timeout);
  });

}


/***
 *    ##     ## #### ########  ########     ######     ###    ########  ########    ##    ##  #######  ######## #### ######## ####  ######     ###    ######## ####  #######  ##    ##
 *    ##     ##  ##  ##     ## ##          ##    ##   ## ##   ##     ##    ##       ###   ## ##     ##    ##     ##  ##        ##  ##    ##   ## ##      ##     ##  ##     ## ###   ##
 *    ##     ##  ##  ##     ## ##          ##        ##   ##  ##     ##    ##       ####  ## ##     ##    ##     ##  ##        ##  ##        ##   ##     ##     ##  ##     ## ####  ##
 *    #########  ##  ##     ## ######      ##       ##     ## ########     ##       ## ## ## ##     ##    ##     ##  ######    ##  ##       ##     ##    ##     ##  ##     ## ## ## ##
 *    ##     ##  ##  ##     ## ##          ##       ######### ##   ##      ##       ##  #### ##     ##    ##     ##  ##        ##  ##       #########    ##     ##  ##     ## ##  ####
 *    ##     ##  ##  ##     ## ##          ##    ## ##     ## ##    ##     ##       ##   ### ##     ##    ##     ##  ##        ##  ##    ## ##     ##    ##     ##  ##     ## ##   ###
 *    ##     ## #### ########  ########     ######  ##     ## ##     ##    ##       ##    ##  #######     ##    #### ##       ####  ######  ##     ##    ##    ####  #######  ##    ##
 */
/**
 * Affiche la notification de panier en fixed et la fait disparaître après un délai.
 */
async function ff_hide_cart_notification() {

  const $cart_notification = $('.cart-notification');
  if (!$cart_notification.hasClass('cart-notification--shown')) {
    return;
  }
  $cart_notification.removeClass('cart-notification--shown');
  if (cart_notification_timeout) clearTimeout(cart_notification_timeout);

  // Fermeture
  gsap.killTweensOf($cart_notification);
  await gsap.to($cart_notification, {
    y         : '100%',
    duration  : 0.6,
    ease      : 'power4.in',
    onComplete: () => {
      $cart_notification.attr('aria-hidden', 'hidden');
      gsap.set($cart_notification, { display: 'block' });
    },
    clearProps: 'transform'
  });

}


/***
 *    ##     ## ########  ########     ###    ######## ########     ######     ###    ########  ########     #######  ##     ##    ###    ##    ## ######## #### ######## ##    ##
 *    ##     ## ##     ## ##     ##   ## ##      ##    ##          ##    ##   ## ##   ##     ##    ##       ##     ## ##     ##   ## ##   ###   ##    ##     ##     ##     ##  ##
 *    ##     ## ##     ## ##     ##  ##   ##     ##    ##          ##        ##   ##  ##     ##    ##       ##     ## ##     ##  ##   ##  ####  ##    ##     ##     ##      ####
 *    ##     ## ########  ##     ## ##     ##    ##    ######      ##       ##     ## ########     ##       ##     ## ##     ## ##     ## ## ## ##    ##     ##     ##       ##
 *    ##     ## ##        ##     ## #########    ##    ##          ##       ######### ##   ##      ##       ##  ## ## ##     ## ######### ##  ####    ##     ##     ##       ##
 *    ##     ## ##        ##     ## ##     ##    ##    ##          ##    ## ##     ## ##    ##     ##       ##    ##  ##     ## ##     ## ##   ###    ##     ##     ##       ##
 *     #######  ##        ########  ##     ##    ##    ########     ######  ##     ## ##     ##    ##        ##### ##  #######  ##     ## ##    ##    ##    ####    ##       ##
 */
/**
 * Met à jour la quantité d'items dans le panier d'achats pour les éléments qui le requiert.
 * @param {Number} quantity Nouvelle quantité d'items.
 */
function ff_update_cart_quantity(quantity) {

  // Cart buttons
  if (parseInt($('.cart-button__items-count').text()) !== quantity) {
    $('.cart-button').each((i, button) => {
      const tl = gsap.timeline();
      gsap.killTweensOf($(button).find('.cart-button__items-count'));
      tl.to($(button).find('.cart-button__items-count'), { y: '100%', duration: 0.6, ease: 'power3.in' });
      tl.call(() => $(button).find('.cart-button__items-count').text(quantity));
      tl.to($(button).find('.cart-button__items-count'), { y: 0, duration: 1.4, ease: 'expo.out' }, '>+0.15');
    });
  }

  // Éléments ".cart-quantity"
  if (parseInt($('.cart-quantity').text()) !== quantity) {
    $('.cart-quantity').text(quantity);
  }

}


/***
 *    ##     ## ########  ########     ###    ######## ########     ######  ######## ##    ## ######## ######## ########  ######## ########      ######  ######## ####  ######  ##    ##    ######## ##       ######## ##     ## ######## ##    ## ########  ######
 *    ##     ## ##     ## ##     ##   ## ##      ##    ##          ##    ## ##       ###   ##    ##    ##       ##     ## ##       ##     ##    ##    ##    ##     ##  ##    ## ##   ##     ##       ##       ##       ###   ### ##       ###   ##    ##    ##    ##
 *    ##     ## ##     ## ##     ##  ##   ##     ##    ##          ##       ##       ####  ##    ##    ##       ##     ## ##       ##     ##    ##          ##     ##  ##       ##  ##      ##       ##       ##       #### #### ##       ####  ##    ##    ##
 *    ##     ## ########  ##     ## ##     ##    ##    ######      ##       ######   ## ## ##    ##    ######   ########  ######   ##     ##     ######     ##     ##  ##       #####       ######   ##       ######   ## ### ## ######   ## ## ##    ##     ######
 *    ##     ## ##        ##     ## #########    ##    ##          ##       ##       ##  ####    ##    ##       ##   ##   ##       ##     ##          ##    ##     ##  ##       ##  ##      ##       ##       ##       ##     ## ##       ##  ####    ##          ##
 *    ##     ## ##        ##     ## ##     ##    ##    ##          ##    ## ##       ##   ###    ##    ##       ##    ##  ##       ##     ##    ##    ##    ##     ##  ##    ## ##   ##     ##       ##       ##       ##     ## ##       ##   ###    ##    ##    ##
 *     #######  ##        ########  ##     ##    ##    ########     ######  ######## ##    ##    ##    ######## ##     ## ######## ########      ######     ##    ####  ######  ##    ##    ######## ######## ######## ##     ## ######## ##    ##    ##     ######
 */
/**
 * Initialise les éléments ".centered-sticky-element" qui auront la position "sticky" et qui seront positionnés verticalement au centre de l'écran.
 */
function ff_update_centered_sticky_elements() {
  $('.centered-sticky-element').each(function () {
    const elem_top = ($(window).innerHeight() - $(this).outerHeight()) / 2;
    if (elem_top) gsap.set($(this), { position: 'sticky', top: elem_top });
  });
}


/***
 *    ######## ########     ###    ##    ##  ######  ########  #######  ########  ##     ##     #######  ##     ##    ###    ##    ## ######## #### ######## ##    ##    #### ##    ## ########  ##     ## ########  ######
 *       ##    ##     ##   ## ##   ###   ## ##    ## ##       ##     ## ##     ## ###   ###    ##     ## ##     ##   ## ##   ###   ##    ##     ##     ##     ##  ##      ##  ###   ## ##     ## ##     ##    ##    ##    ##
 *       ##    ##     ##  ##   ##  ####  ## ##       ##       ##     ## ##     ## #### ####    ##     ## ##     ##  ##   ##  ####  ##    ##     ##     ##      ####       ##  ####  ## ##     ## ##     ##    ##    ##
 *       ##    ########  ##     ## ## ## ##  ######  ######   ##     ## ########  ## ### ##    ##     ## ##     ## ##     ## ## ## ##    ##     ##     ##       ##        ##  ## ## ## ########  ##     ##    ##     ######
 *       ##    ##   ##   ######### ##  ####       ## ##       ##     ## ##   ##   ##     ##    ##  ## ## ##     ## ######### ##  ####    ##     ##     ##       ##        ##  ##  #### ##        ##     ##    ##          ##
 *       ##    ##    ##  ##     ## ##   ### ##    ## ##       ##     ## ##    ##  ##     ##    ##    ##  ##     ## ##     ## ##   ###    ##     ##     ##       ##        ##  ##   ### ##        ##     ##    ##    ##    ##
 *       ##    ##     ## ##     ## ##    ##  ######  ##        #######  ##     ## ##     ##     ##### ##  #######  ##     ## ##    ##    ##    ####    ##       ##       #### ##    ## ##         #######     ##     ######
 */
/**
 * Transforme les champs de quantity WooCommerce pour y ajouter les boutons de décrémentation et d'incrémentation.
 */
function ff_transform_quantity_inputs() {
  $('.quantity .qty[type="number"]:not(.qty--transformed)').each((i, input_element) => {

    // Callbacks de mise à jour au clic des boutons
    const min = parseInt($(input_element).attr('min'));
    const max = parseInt($(input_element).attr('max'));
    const update = (value) => {
      $(input_element)
        .val(value)
        .trigger('change');
    };
    const decrement = (e) => {
      e.preventDefault();
      const value = Math.max(min, parseInt($(input_element).val()) - 1);
      update(value);
    };
    const increment = (e) => {
      e.preventDefault();
      const value = Math.min(max, parseInt($(input_element).val()) + 1);
      update(value);
    };

    // Ajout des éléments au DOM
    const decrement_button = document.createElement('button');
    const increment_button = document.createElement('button');
    $(decrement_button)
      .addClass('qty-button qty-decrement-button')
      .insertBefore(input_element)
      .on('click', decrement)
      .attr('aria-label', __('Diminuer la quantité de 1', 'fatfish'));
    $(increment_button)
      .addClass('qty-button qty-increment-button')
      .insertAfter(input_element)
      .on('click', increment)
      .attr('aria-label', __('Augmenter la quantité de 1', 'fatfish'));
    $(input_element).addClass('qty--transformed');

  });
}

/***
 *    ##     ## ########  ########     ###    ######## ########       ###    ########  ######## ####  ######  ##       ########     ######     ###    ########  ########   ######     ######## #### ######## ##       ########  ######     ########  #######  ##    ## ########     ######  #### ######## ########
 *    ##     ## ##     ## ##     ##   ## ##      ##    ##            ## ##   ##     ##    ##     ##  ##    ## ##       ##          ##    ##   ## ##   ##     ## ##     ## ##    ##       ##     ##     ##    ##       ##       ##    ##    ##       ##     ## ###   ##    ##       ##    ##  ##       ##  ##
 *    ##     ## ##     ## ##     ##  ##   ##     ##    ##           ##   ##  ##     ##    ##     ##  ##       ##       ##          ##        ##   ##  ##     ## ##     ## ##             ##     ##     ##    ##       ##       ##          ##       ##     ## ####  ##    ##       ##        ##      ##   ##
 *    ##     ## ########  ##     ## ##     ##    ##    ######      ##     ## ########     ##     ##  ##       ##       ######      ##       ##     ## ########  ##     ##  ######        ##     ##     ##    ##       ######    ######     ######   ##     ## ## ## ##    ##        ######   ##     ##    ######
 *    ##     ## ##        ##     ## #########    ##    ##          ######### ##   ##      ##     ##  ##       ##       ##          ##       ######### ##   ##   ##     ##       ##       ##     ##     ##    ##       ##             ##    ##       ##     ## ##  ####    ##             ##  ##    ##     ##
 *    ##     ## ##        ##     ## ##     ##    ##    ##          ##     ## ##    ##     ##     ##  ##    ## ##       ##          ##    ## ##     ## ##    ##  ##     ## ##    ##       ##     ##     ##    ##       ##       ##    ##    ##       ##     ## ##   ###    ##       ##    ##  ##   ##      ##
 *     #######  ##        ########  ##     ##    ##    ########    ##     ## ##     ##    ##    ####  ######  ######## ########     ######  ##     ## ##     ## ########   ######        ##    ####    ##    ######## ########  ######     ##        #######  ##    ##    ##        ######  #### ######## ########
 */
/**
 * Met à jour le font size des titres des cartes d'article dy type "balado" selon la hauteur de l'overflow du contenu de ceux-ci.
 */
window.ff_update_article_cards_titles_font_size = function () {
  $('.article-card__podcast-title').each((i, card_title) => {
    $(card_title).css('font-size', ''); // Reset
    setTimeout(() => { // *setTimeout pour s'assurer que le font-size ai bien fini d'être ré-initialisé
      const overflowing_height = card_title.scrollHeight - card_title.clientHeight;
      if (overflowing_height > 8) { // *Puisque le line-height est à 1em, le texte overflow le conteneur même si visuellement ce n'est pas le cas. C'est pour ça qu'on regarde si la différence est plus que 8px
        const rem_overflowing_height = overflowing_height / rem;
        const font_size_multiplier = Math.max(0.65, gsap.utils.mapRange(2, 5.55, 0.8725, 0.83, rem_overflowing_height));
        $(card_title).css('font-size', `calc(var(--h3_font_size) * ${font_size_multiplier})`);
      }
    });
  });
};


/***
 *     ######   ######  ########   #######  ##       ##          ########  #######        ###    ##    ##  ######  ##     ##  #######  ########
 *    ##    ## ##    ## ##     ## ##     ## ##       ##             ##    ##     ##      ## ##   ###   ## ##    ## ##     ## ##     ## ##     ##
 *    ##       ##       ##     ## ##     ## ##       ##             ##    ##     ##     ##   ##  ####  ## ##       ##     ## ##     ## ##     ##
 *     ######  ##       ########  ##     ## ##       ##             ##    ##     ##    ##     ## ## ## ## ##       ######### ##     ## ########
 *          ## ##       ##   ##   ##     ## ##       ##             ##    ##     ##    ######### ##  #### ##       ##     ## ##     ## ##   ##
 *    ##    ## ##    ## ##    ##  ##     ## ##       ##             ##    ##     ##    ##     ## ##   ### ##    ## ##     ## ##     ## ##    ##
 *     ######   ######  ##     ##  #######  ######## ########       ##     #######     ##     ## ##    ##  ######  ##     ##  #######  ##     ##
 */
/**
 * Défile la page vers l'élément associé au anchor présent dans un URL donné ou dans l'URL actuel.
 * @param {String} url URL à vérifié. Si non spécifié, l'URL actuel sera vérifié. (Optionnel).
 * @returns {Boolean} Si oui ou non l'élément associé est trouvé et si le défilement est effectué.
 */
function ff_scroll_to_anchor(url) {

  url = typeof url !== 'string' ? window.location : new URL(url);
  if (!url.hash) {
    return false;
  }

  let selector;
  if (url.hash.includes('?')) {
    selector = url.hash.slice(0, url.hash.indexOf('?'));
  }
  else {
    selector = url.hash;
  }
  if ($(selector).length == 0) {
    return false;
  }

  const offset = ($(selector).attr('data-scroll-to-offset') && !isNaN(parseFloat($(selector).attr('data-scroll-to-offset'))) ? parseFloat($(selector).attr('data-scroll-to-offset')) : 0);
  if (ff_scroll.lenis) ff_scroll.lenis.dimensions.onContentResize();
  ff_scroll.set_scroll_top($(selector).offset().top - offset);
  return true;

}


/***
*    ######## ########    ##      ## ########        ###    ##       ######## ########  ########  ######     ##     ##  #######   #######  ##    ##  ######
*    ##       ##          ##  ##  ## ##     ##      ## ##   ##       ##       ##     ##    ##    ##    ##    ##     ## ##     ## ##     ## ##   ##  ##    ##
*    ##       ##          ##  ##  ## ##     ##     ##   ##  ##       ##       ##     ##    ##    ##          ##     ## ##     ## ##     ## ##  ##   ##
*    ######   ######      ##  ##  ## ########     ##     ## ##       ######   ########     ##     ######     ######### ##     ## ##     ## #####     ######
*    ##       ##          ##  ##  ## ##           ######### ##       ##       ##   ##      ##          ##    ##     ## ##     ## ##     ## ##  ##         ##
*    ##       ##          ##  ##  ## ##           ##     ## ##       ##       ##    ##     ##    ##    ##    ##     ## ##     ## ##     ## ##   ##  ##    ##
*    ##       ##           ###  ###  ##           ##     ## ######## ######## ##     ##    ##     ######     ##     ##  #######   #######  ##    ##  ######
*/
if (typeof ff_wp_alerts !== 'undefined') {

  // ======================================================================================
  // Filtre les options des FF_Modal créées par FF WP Alerts
  // ======================================================================================
  ff_wp_alerts.hooks.add_filter('ff_popup_options', 'fatfish', (options) => ({
    ...options,
    content_classes: 'wysiwyg',
    on_creation    : ({ self }) => {
      if (self.elements.close_cta) $(self.elements.close_cta).addClass('cta');
    },
    on_open_start: () => {
      ff_scroll.update_lenis_prevent_elements();
      if (options.is_modal) ff_scroll.lock_scroll();
    },
    on_close_start: () => {
      if (options.is_modal) ff_scroll.unlock_scroll();
    },
    in_animation: ({ timeline, self }) => {
      if (self.elements.bg) {
        timeline.from(self.elements.bg, { opacity: 0, duration: 1.4, ease: 'custom.inOutSlowOut' });
      }
      timeline.add(ff_animations.get_animation('generic-slide-in', self.elements.content), self.elements.bg ? '>-1' : 0);
      timeline.set(self.elements.close_button, { transition: 'none' }, '>-1.1');
      timeline.from(self.elements.close_button, { scale: 0, duration: 0.8, ease: 'expo.out', clearProps: 'transition,scale' }, '<');
    },
    out_animation: ({ timeline, self }) => {
      timeline.to(self.elements.content, { y: '3rem', duration: 0.5, ease: 'power2.in' }, 0);
      timeline.to(self.elements.content, { opacity: 0, duration: 0.35, ease: 'custom.inOutSlowOut' }, '<+0.15');
      timeline.set(self.elements.close_button, { transition: 'none' }, 0);
      timeline.to(self.elements.close_button, { scale: 0, y: '0.75rem', duration: 0.35, ease: 'power2.in' }, 0);
      timeline.to(self.elements.bg, { opacity: 0, duration: 1.4, ease: 'custom.inOutSlowOut' }, 0.2);
    }
  }));

  // ======================================================================================
  // Filtre les options des FF_Banner créées par FF WP Alerts
  // ======================================================================================
  ff_wp_alerts.hooks.add_filter('ff_banner_options', 'fatfish', (options) => ({
    ...options,
    content_classes: 'wysiwyg',
    on_creation    : ({ self }) => {

      if (self.elements.close_cta) $(self.elements.close_cta).addClass('cta');

      if ($('html').hasClass('first-load-anim-completed')) return;
      if (self.position == 'bottom') {
        gsap.set('.header__logo-part', { y: $(self.elements.container).innerHeight() + $('.header__top-container').innerHeight() });
      }
      else if (self.position == 'top') {
        gsap.set('.header__top-container', { y: -$(self.elements.container).innerHeight() - $('.header__top-container').innerHeight() });
      }
      gsap.set(self.elements.container, {
        y: `${-100 * (self.position_type == 'fixed' && self.position == 'bottom' ? -1 : 1)}%`
      });
      $(document).one('ff-first-load-anim-start', () => {
        gsap.to(self.elements.container, { y: 0, duration: 2, ease: 'expo.out', clearProps: 'y', delay: 1.4, force3D: false });
      });

    },
    on_open_complete : () => ScrollTrigger.refresh(),
    on_close_complete: () => ScrollTrigger.refresh()
  }));

}


/***
 *    ########     ###     ######   ########    ######## ########     ###    ##    ##  ######  #### ######## ####  #######  ##    ##  ######
 *    ##     ##   ## ##   ##    ##  ##             ##    ##     ##   ## ##   ###   ## ##    ##  ##     ##     ##  ##     ## ###   ## ##    ##
 *    ##     ##  ##   ##  ##        ##             ##    ##     ##  ##   ##  ####  ## ##        ##     ##     ##  ##     ## ####  ## ##
 *    ########  ##     ## ##   #### ######         ##    ########  ##     ## ## ## ##  ######   ##     ##     ##  ##     ## ## ## ##  ######
 *    ##        ######### ##    ##  ##             ##    ##   ##   ######### ##  ####       ##  ##     ##     ##  ##     ## ##  ####       ##
 *    ##        ##     ## ##    ##  ##             ##    ##    ##  ##     ## ##   ### ##    ##  ##     ##     ##  ##     ## ##   ### ##    ##
 *    ##        ##     ##  ######   ########       ##    ##     ## ##     ## ##    ##  ######  ####    ##    ####  #######  ##    ##  ######
 */
const barba_transitions = [

  /***
   *     #####  ###### ######   ##   #    # #      #####
   *     #    # #      #       #  #  #    # #        #
   *     #    # #####  #####  #    # #    # #        #
   *     #    # #      #      ###### #    # #        #
   *     #####  ###### #      #    #  ####  ######   #
   */
  {
    name: 'default',

    // ===========================================================================================
    // Once
    // ===========================================================================================
    once: function (data) {
      return new Promise((resolve) => {
        ff_barba_once(data).then(resolve);
      });
    },

    // ===========================================================================================
    // Leave
    // ===========================================================================================
    leave: function () {
      return new Promise(async (resolve) => {

        // =================================================================================
        // Fermeture du menu
        // =================================================================================
        const screen_menu_promise = screen_menu.close();

        // =================================================================================
        // Si une bannière relative ou "fixed-top" (FF WP Alerts) se trouve sur la page, on anime le top de la barre du haut du header pour retirer le offset qu'elle pourrait avoir
        // =================================================================================
        let header_top_container_animation;
        if ($('.ff-banner--relative, .ff-banner--fixed-top').get(0)) {
          gsap.killTweensOf('.header__top-container');
          header_top_container_animation = gsap.to('.header__top-container', { top: (i, target) => -Math.max(target.getBoundingClientRect().top, 0) + parseFloat($(target).css('top')), duration: 1.3, ease: 'expo.inOut' });
        }

        // =================================================================================
        // Animation de sortie de page
        // =================================================================================
        await Promise.all([
          header_top_container_animation,
          screen_menu_promise,
          ff_animations.get_page_leave_animation()
        ]);
        resolve();

      });


    },

    // ===========================================================================================
    // Enter
    // ===========================================================================================
    enter: function (data) {
      return new Promise(async (resolve) => {

        // =================================================================================
        // Si une bannière relative ou "fixed-top" (FF WP Alerts) se trouve sur la page, on anime le top de la barre du haut du header
        // =================================================================================
        if (data.current.container && $('.ff-banner--relative, .ff-banner--fixed-top').get(0)) {
          gsap.from('.header__top-container', { top: -$('.ff-banner--relative, .ff-banner--fixed-top').innerHeight(), duration: 1.3, ease: 'expo.inOut', clearProps: 'top' });
        }

        // =================================================================================
        // Chargement des ressources
        // =================================================================================
        await Promise.all([
          ff_init_plyr_players(),
          ff_init_ff_sliders()
        ]);

        // =================================================================================
        // Gestion du scroll
        // =================================================================================
        if (ff_scroll.lenis) {
          ff_scroll.lenis.dimensions.onContentResize();
        }

        // Scroll vers un anchor
        if (data.next.url.hash) {
          const scroll_to_anchor_success = ff_scroll_to_anchor(data.next.url.href);
          if (!scroll_to_anchor_success) {
            ff_scroll.reset();
          }
        }

        // Scroll Position sur un back
        else if (data.trigger == 'back' && !$(data.next.container).find('.lazy-load-content').get(0)) { // *Si un conteneur de lazyload se trouve dans la prochaine page, on ne scroll pas vers la position précédente
          ff_scroll.set_scroll_top(ff_last_scroll_pos);
        }

        // Reset FF Scroll
        else {
          ff_scroll.reset();
        }

        ScrollTrigger.refresh();

        // Animation d'entrée de pages
        const page_enter_animation = ff_animations.get_page_enter_animation(data).delay(0.2);
        if (page_enter_animation) {
          await page_enter_animation;
        }
        resolve();

      });
    }
  },

  /***
   *      ####    ##   #####   ##   #       ####   ####  #    # ######
   *     #    #  #  #    #    #  #  #      #    # #    # #    # #
   *     #      #    #   #   #    # #      #    # #      #    # #####
   *     #      ######   #   ###### #      #    # #  ### #    # #
   *      ####  #    #   #   #    # ######  ####   ####   ####  ######
   */
  {
    name: 'catalogue',
    from: {
      namespace: ['archive-product', 'taxonomy-product_cat'],
      custom   : (data) => data.trigger && ($(data.trigger).closest('.catalogue__navigation-item').get(0) || $(data.trigger).attr('id') == 'catalogue-phone-navigation-category')
    },

    // ===========================================================================================
    // Once
    // ===========================================================================================
    once: function (data) {
      return new Promise((resolve) => {
        ff_barba_once(data).then(resolve);
      });
    },

    // ===========================================================================================
    // Leave
    // ===========================================================================================
    leave: function ({ trigger }) {
      return new Promise(async (resolve) => {

        // Met à jour l'état actif du lien cliqué de la navigation
        if (trigger && $(trigger).closest('.catalogue__navigation-item').get(0)) {
          $('.catalogue__navigation-item--current').removeClass('catalogue__navigation-item--current');
          $(trigger).closest('.catalogue__navigation-item').addClass('catalogue__navigation-item--current');
        }

        // Met à jour le scroll selon le offset du conteneur des livres
        let scroll_promise = true;
        const set_scroll_instant = !is_phone_display && ScrollTrigger.positionInViewport('.catalogue__books', 'bottom') >= 1; // Si le bas du conteneur se trouve plus bas que le bas de l'écran, on met à jour le scroll instantanément après l'animation
        if (!set_scroll_instant) {
          scroll_promise = ff_scroll.scroll_to(0, {
            duration: 1.2 + gsap.utils.mapRange(0, 3000, 0, 0.125, ff_scroll.get_scroll_top()),
            easing  : (val) => (val < 0.5 ? 8 * val * val * val * val : 1 - (-2 * val + 2) ** 4 / 2)
          });
        }

        // Animation de sortie
        const tl = gsap.timeline();
        if (!is_phone_display) {
          tl.to('.catalogue__books', { y: '-9rem', duration: 0.65, ease: 'power2.in' });
          tl.to('.catalogue__category-description', { opacity: 0, duration: 0.5, ease: 'power2.in' }, '<');
        }
        tl.to('.catalogue__books', { opacity: 0, duration: 0.5, ease: CustomEase.create('custom', 'M0,0,C0.7,0,0.6,0.814,1,1') }, '<0.15');

        await Promise.all([scroll_promise, tl]);
        if (set_scroll_instant) {
          ff_scroll.set_scroll_top(0);
        }
        ff_scroll.lock_scroll();

        resolve();

      });
    },

    // ===========================================================================================
    // Enter
    // ===========================================================================================
    enter: function ({ next }) {
      return new Promise(async (resolve) => {

        const on_screen_books = $(next.container).find('.catalogue__books .book').toArray().filter((book_element) => ScrollTrigger.isInViewport(book_element));
        const category_description = $(next.container).find('.catalogue__category-description').get(0) ?? false;
        gsap.set('main, .footer', { opacity: 1 });
        gsap.set('.footer', { clearProps: 'y' });

        // On attend que les nouvelles images soient tous chargées avant de continuer
        gsap.set([on_screen_books, category_description], { opacity: 0 });
        await Promise.all($(next.container).find('.catalogue__books .book__image').toArray().map((book_image) => new Promise((image_resolve) => {
          if (book_image.complete && book_image.naturalHeight !== 0) { // Bail si l'image est déjà chargée
            image_resolve();
            return;
          }
          $(book_image).on('load', image_resolve);
        })));

        // Animation d'entrée
        await ff_animations.get_animation('generic-slide-in', [category_description, on_screen_books]).delay(0.2);
        ff_scroll.unlock_scroll();
        resolve();

      });
    }
  }
];


/***
*    ########     ###    ########  ########     ###
*    ##     ##   ## ##   ##     ## ##     ##   ## ##
*    ##     ##  ##   ##  ##     ## ##     ##  ##   ##
*    ########  ##     ## ########  ########  ##     ##
*    ##     ## ######### ##   ##   ##     ## #########
*    ##     ## ##     ## ##    ##  ##     ## ##     ##
*    ########  ##     ## ##     ## ########  ##     ##
*/
/***
*     #####    ##   #####  #####    ##       ####  #    #  ####  ######
*     #    #  #  #  #    # #    #  #  #     #    # ##   # #    # #
*     #####  #    # #    # #####  #    #    #    # # #  # #      #####
*     #    # ###### #####  #    # ######    #    # #  # # #      #
*     #####  #    # #    # #####  #    #     ####  #    #  ####  ######
*/
/**
 * Exécute l'animation d'entrée de page du premier chargement du navigateur de Barba.
 *
 * @param {object} data Objet qui contient les propriétés de la page courante et la page suivante ainsi que le déclencheur. (Argument donné par le hook de Barba).
 */
function ff_barba_once(data) {
  return new Promise(async (resolve) => {

    // Préparation de l'animation et affichage de la page
    const page_load_animation = ff_animations.get_page_load_animation(data);
    if (page_load_animation) {
      page_load_animation.pause();
    }
    gsap.set('body', { opacity: 1 });
    $('html').addClass('barba-transitioning');

    // On attend la fin du chargement de la page et des ressources
    await Promise.all([
      (!page_has_loaded ? page_load_promise : true),
      ff_init_plyr_players(),
      ff_init_ff_sliders()
    ]);
    ScrollTrigger.refresh();

    // Scroll vers l'anchor dans l'URL
    ff_scroll_to_anchor();

    // Update le total du cart
    ff_update_cart_total();

    // Animation d'entrée de page
    if (page_load_animation) {
      await page_load_animation.play();
    }

    // Fin de la transition
    $('html').removeClass('barba-transitioning');
    resolve();

  });
}


/***
 *     #####    ##   #####  #####    ##        ##   ###### ##### ###### #####     #      ######   ##   #    # ######
 *     #    #  #  #  #    # #    #  #  #      #  #  #        #   #      #    #    #      #       #  #  #    # #
 *     #####  #    # #    # #####  #    #    #    # #####    #   #####  #    #    #      #####  #    # #    # #####
 *     #    # ###### #####  #    # ######    ###### #        #   #      #####     #      #      ###### #    # #
 *     #####  #    # #    # #####  #    #    #    # #        #   ###### #    #    ###### ###### #    #   ##   ######
 */
/**
 * Remplace les éléments hors du conteneur de Barba avec les les éléments correspndants de la prochaine page.
 *
 * @param {object} data Objet qui contient les propriétés de la page courante et la page suivante ainsi que le déclencheur. (Argument donné par le hook de Barba).
 */
function ff_barba_after_leave(data) {

  // ========================================================
  // Remplacement des éléments hors du conteneur de Barba, si applicable
  // ========================================================
  const $next_page_html_element = $('<div/>').html(data.next.html);

  // HTML des <header> et des <footer> de la page courante et suivante
  const current_cart_count = $('.cart-button__items-count').text();
  const current_header_html = ($('header').html() || '').trim();
  const next_header_html = $next_page_html_element.find('header').html();
  const current_footer_html = $('footer').html();
  const next_footer_html = $next_page_html_element.find('footer').html();

  // Remplacement du <header> si celui de la page courante et celui de la prochaine page sont différents
  if (current_header_html && next_header_html && current_header_html != next_header_html) {
    const next_page_header_element = $next_page_html_element.find('header').filter((i, header) => !$(header).closest('main').get(0));
    $('header').replaceWith(next_page_header_element);
    $('.cart-button__items-count').text(current_cart_count);
  }

  // Remplacement du <footer> si celui de la page courante et celui de la prochaine page sont différents
  if (current_footer_html && next_footer_html && current_footer_html != next_footer_html) {
    const next_page_footer_element = $next_page_html_element.find('footer').filter((i, footer) => !$(footer).closest('main').get(0));
    $('footer').replaceWith(next_page_footer_element);
  }

  // Remplacement de la barre d'administration de Wordpress
  const next_page_wp_admin_bar = $($next_page_html_element).find('#wpadminbar');
  if (next_page_wp_admin_bar) {
    $('#wpadminbar').replaceWith(next_page_wp_admin_bar);
  }

  // Remplacement de la fenêtre de Query Monitor
  const next_page_query_monitor_window = $($next_page_html_element).find('#query-monitor-main');
  if (next_page_query_monitor_window) {
    $('#query-monitor-main').replaceWith(next_page_query_monitor_window);
  }

  // ========================================================
  // Si on détecte que la prochaine page est la page "Panier" ou la page "Paiement", on cancel la transition et on rafraîchit la page
  // ========================================================
  if (['template-cart', 'template-checkout'].includes(data.next.namespace)) {
    barba.force(window.location.href);
  }

}

/***
*     #####    ##   #####  #####    ##      #####  ###### ######  ####  #####  ######    ###### #    # ##### ###### #####
*     #    #  #  #  #    # #    #  #  #     #    # #      #      #    # #    # #         #      ##   #   #   #      #    #
*     #####  #    # #    # #####  #    #    #####  #####  #####  #    # #    # #####     #####  # #  #   #   #####  #    #
*     #    # ###### #####  #    # ######    #    # #      #      #    # #####  #         #      #  # #   #   #      #####
*     #####  #    # #    # #####  #    #    #####  ###### #       ####  #    # ######    ###### #    #   #   ###### #    #
*/
/**
 * Initialiser les éléments du conteneur de la nouvelle page de Barba.
 *
 * @param {object} data Objet qui contient les propriétés de la page courante et la page suivante ainsi que le déclencheur. (Argument donné par le hook de Barba).
 */
function ff_barba_before_enter(data) {

  const next_container = (data) ? data.next.container : 'main';
  const is_first_load = data.current.container == null;

  // ========================================================
  // Mise à jour de la variable du HTML initial de la page courante
  // ========================================================
  current_page_initial_html = data.next.html;

  // ========================================================
  // Ajustement de la variable CSS "--vh"
  // ========================================================
  ff_fix_vh();

  // ========================================================
  // Modification des liens INTERNES pour pas qu'il n'y ait de conflit avec Barba
  // ========================================================
  const $internal_file_links = $(`a[href*="//${window.location.host}"]`).filter((link_i, link) => {
    const href = $(link).attr('href');
    return (/\.[^./\s]+$/).test(href);
  });

  const $internal_links = $(`a[href*="//${window.location.host}"]`).not('[href*="javascript:void(0)"], [href^="#"], [href^="mailto:"], [href^="tel:"], [download]').not($internal_file_links);
  $internal_links.each(function () {
    if ($(this).attr('href') && !$(this).hasClass('ab-item')) {
      // Rajoute un slash à la fin s'il n'y en a pas ET s'il n'y a pas de paramètre dans le href
      this.href = (this.href.slice(-1) != '/' && this.href.indexOf('?') == -1 && this.href.indexOf('#') == -1 ? `${this.href}/` : this.href);

      // Remplace le protocol s'il ne concorde pas avec celui de l'URL
      this.href = (this.href.indexOf(window.location.protocol) <= 0 ? `${window.location.protocol}//${this.href.slice(this.href.indexOf(window.location.host))}` : this.href);
    }
  });

  // Ajout du [target="_blank"] au liens fichiers internes
  $internal_file_links.each(function () {
    this.target = '_blank';
  });

  // ========================================================
  // Modification des liens EXTERNES pour pas qu'il n'y ait de conflit avec Barba (On ajoute le protocol avant le href s'il n'y en a pas) et pour ajouter un [target="_blank"]
  // ========================================================
  $('a').not(`[href*="${window.location.host}"], [href*="javascript:void(0)"], [href^="#"], [href^="mailto:"], [href^="tel:"]`).each(function () {
    // Modification du [href]
    if ($(this).attr('href')) {
      const href = $(this).attr('href');
      if (href.indexOf('http://') < 0 && href.indexOf('https://') < 0) {
        $(this).attr('href', `http://${href}`);
      }
    }
    this.target = '_blank'; // Ajout du [target="_blank"]
  });

  // ========================================================
  // Ajout des "body classes" de Wordpress au <body>
  // ========================================================
  const body_classes = $(next_container).attr('data-body-class');
  if (body_classes) {
    document.body.className = body_classes;
  }

  // ========================================================
  // Applique les styles personnalisés aux champs de type "file"
  // ========================================================
  ff_add_file_inputs_interaction();

  // ========================================================
  // Initialisation des FFGliders
  // ========================================================
  ff_init_ff_gliders();

  // ========================================================
  // Initialisation des éléments Selectric
  // ========================================================
  ff_init_selectric_elements();

  // ========================================================
  // Initialisation des cartes Google Maps
  // ========================================================
  ff_init_google_maps();

  // ========================================================
  // Initialisation des éléments sticky centrés
  // ========================================================
  ff_update_centered_sticky_elements();

  // ========================================================
  // Transforme les inputs de quantités
  // ========================================================
  ff_transform_quantity_inputs();

  // ========================================================
  // Modification de certains éléments WooCommerce
  // ========================================================
  // Page "Panier"
  $('.shipping-calculator-button').addClass('cta');
  $('.return-to-shop a.button').addClass('cta');

  // Page "Paiement"
  $('.woocommerce-billing-fields__field-wrapper, .woocommerce-shipping-fields__field-wrapper').addClass('u-grid-visual');

}

/***
*     # #    # # ##### #   ##   #      #  ####    ##   ##### #  ####  #    #
*     # ##   # #   #   #  #  #  #      # #       #  #    #   # #    # ##   #
*     # # #  # #   #   # #    # #      #  ####  #    #   #   # #    # # #  #
*     # #  # # #   #   # ###### #      #      # ######   #   # #    # #  # #
*     # #    # #   #   # #    # ###### #  ####  #    #   #   #  ####  #    #
*/
/**
 * Initialise le "routing" de Barba.
 */
function ff_init_barba_routing() {

  // =================================================================================================================
  // Ajout de Scripts/CSS
  // =================================================================================================================
  const barba_scripts = {
    init: function () {
      if ($('.plyr').length) this.load_plyr();
      if ($('.FFSlider').length) this.load_ff_slider();
    },
    load_plyr: function () {
      ff_load_file('https://cdn.plyr.io/3.7.8/plyr.js', 'js', 'ff-plyr-js');
      ff_load_file('https://cdn.plyr.io/3.7.3/plyr.css', 'css', 'ff-plyr-css');
    },
    load_ff_slider: function () {
      ff_load_file(`${ff_theme_url}dist/scripts/ff-js-slider.min.js`, 'js', 'ff-slider-js');
      ff_load_file(`${ff_theme_url}dist/styles/ff-js-slider.min.css`, 'css', 'ff-slider-css');
    }
  };

  // =============================================================
  // Hooks globaux
  // =============================================================
  // Début de Barba
  barba.hooks.before(() => {
    $('html').addClass('barba-transitioning');
  });

  // Reset certains éléments avant l'animation de sortie de page
  barba.hooks.leave((data) => {

    // Last Scroll Position
    if (data.trigger !== 'back') ff_last_scroll_pos = ff_scroll.get_scroll_top();

    // Retirer la classe "on-sun-section" ajouté par un ScrollTrigger
    setTimeout(() => {
      $('html').removeClass('on-sun-section');
    });

    // Retrait de certaines classes sur les éléments du header
    setTimeout(() => {
      $('.header__top-container').removeClass('header__top-container--orange');
      $('.header__logo-container').removeClass('header__logo-container--orange');
    });

    // Retire la couleur d'arrière-plan de page ajouté par les ScrollTrigger
    $('html')
      .removeClass((i, class_name) => (class_name.match(/\bpage-bg-color-\S+/g) || []).join(' '))
      .css('backgroundColor', '');
    if (screen_menu.is_open) {
      gsap.set('html', { transition: 'none' });
      setTimeout(() => gsap.set('html', { clearProps: 'transition' }));
    }

    // Fermeture de la notification de panier
    ff_hide_cart_notification();

  });

  // Hook à utiliser pour modifier les éléments hors du conteneur Barba
  barba.hooks.afterLeave((data) => {
    ff_barba_after_leave(data);
  });

  // Hook à utiliser pour initialiser les éléments du conteneur de la nouvelle page de Barba
  barba.hooks.beforeEnter((data) => {
    barba_scripts.init();
    $(data.current.container).remove();
    ff_barba_before_enter(data);
  });

  // Fin de Barba
  barba.hooks.after(() => {

    $('html').removeClass('barba-transitioning');

    // Fix Barba pour s'assurer de compter tous les page views
    if (typeof gtag != 'undefined') {
      gtag('event', 'page_view', {
        page_title   : document.title,
        page_location: location.href,
        page_path    : location.pathname
      });
    }

  });


  // =============================================================
  // Init
  // =============================================================
  barba.init({
    timeout       : 8000,
    debug         : !!ff_local_mode,
    transitions   : barba_transitions,
    cacheIgnore   : true,
    prefetchIgnore: true,

    // Force Barba à rediriger vers la bonne page sur un timeout au lieu de rafraîchir la page (l'alternative est de laisser debug à true)
    requestError: (trigger, action, url, response) => {
      if (action === 'click') {
        barba.force(barba.url.parse(url).path);
        ff_fake_function_to_stop_script_execution();
      }
    },

    // Empêcher rafraîchissement de la page actuelle si on clique sur un lien pointant vers elle-même
    prevent: (data) => {

      const event_was_a_click = data.event.type === 'click';
      const link_anchor = (data.href.indexOf('#') != -1 ? data.href.slice(data.href.indexOf('#')) : false);
      let current_url = window.location.href;
      if (current_url.indexOf('#') > 0) { // Retirer les anchors de l'URL de comparaison
        current_url = current_url.substr(0, current_url.indexOf('#'));
      }
      const destination_is_current = current_url === data.href;

      // Si la destination est la page courante, on scroll vers le haut de la page
      if (event_was_a_click && destination_is_current) {
        data.event.preventDefault();
        screen_menu.close();
        ff_scroll.scroll_to(0);
      }

      // Si la destination est la page courante avec un anchor dans l'url, on scroll à l'élément correspondant
      if (event_was_a_click && link_anchor && current_url === data.href.slice(0, data.href.indexOf('#')) && !$(data.el).hasClass('ab-item') && !$(data.el).hasClass('shipping-calculator-button')) {
        if ($(link_anchor).length != 0) {
          data.event.preventDefault();
          screen_menu.close();
          const offset = ($(data.el).attr('data-scroll-to-offset') && !isNaN(parseFloat($(data.el).attr('data-scroll-to-offset'))) ? parseFloat($(data.el).attr('data-scroll-to-offset')) : false);
          ff_scroll.scroll_to(link_anchor, { offset: offset });
        }
      }

      // Si le lien termine avec l'extension d'un fichier, on bloque barba
      if ((/\.[^./\s]+$/).test(data.href)) {
        return true;
      }

      // Si on clique sur un des liens de la bar d'admin ou si le lien possède la classe "no-barba", on bloque Barba
      if ($(data.el).hasClass('ab-item') || $(data.el).closest('.user_switching').length > 0 || $(data.el).hasClass('no-barba')) {
        return true;
      }

      // Si on clique sur un lien ayant la classe ".no-barba" (ou autres classes de liens de Woocommerce), on bloque Barba
      if ($(data.el).hasClass('remove') || $(data.el).hasClass('restore-item') || $(data.el).hasClass('checkout-button') || $(data.el).hasClass('cart-button')) {
        return true;
      }

      // Si on est dans la page "Panier" ou "Paiement"
      if (['template-cart', 'template-checkout'].includes($('main').attr('data-barba-namespace'))) {
        return true;
      }

      return false;

    }
  });
}


/***
 *     ######   ######## ########     ######     ###    ########  ########    ########  #######  ########    ###    ##
 *    ##    ##  ##          ##       ##    ##   ## ##   ##     ##    ##          ##    ##     ##    ##      ## ##   ##
 *    ##        ##          ##       ##        ##   ##  ##     ##    ##          ##    ##     ##    ##     ##   ##  ##
 *    ##   #### ######      ##       ##       ##     ## ########     ##          ##    ##     ##    ##    ##     ## ##
 *    ##    ##  ##          ##       ##       ######### ##   ##      ##          ##    ##     ##    ##    ######### ##
 *    ##    ##  ##          ##       ##    ## ##     ## ##    ##     ##          ##    ##     ##    ##    ##     ## ##
 *     ######   ########    ##        ######  ##     ## ##     ##    ##          ##     #######     ##    ##     ## ########
 */
function ff_update_cart_total() {
  ff_ajax({
    dataType: 'JSON',
    data    : {
      action: 'ff-get-cart-total'
    },
    success: function (response) {
      ff_update_cart_quantity(response.cart_contents_count);
    }
  });
}
